import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Form,
  Dropdown,
} from "react-bootstrap";
import CommonTable from '../components/CommonTable/CommonTable';
import EmptyState from '../components/EmptyState/EmptyState';
import { usePageToolbar } from '../layouts/nav/PageToolbarContext';
import '../tasks/tasklist.css';
import { 
  FiFolder, 
  FiFile, 
  FiUpload,
  FiEdit2,
  FiTrash2,
  FiDownload,
  FiMove,
  FiFolderPlus,
  FiShare2,
  FiStar,
  FiX,
  FiPlus,
} from 'react-icons/fi';
import {
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileArchive,
  FaFileAlt,
  FaFolder
} from 'react-icons/fa';
import './documentDrive.css';
import './commonstyle.css';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import BackToTop from '../components/BackToTop/BackToTop';
import DocumentUploadForm from './DocumentUploadForm';
import DocumentShareForm from './DocumentShareForm';
import ShareDocumentModal from './ShareDocumentModal';
import axiosInstance from '../../services/AxiosInstance';
import { buildDocumentSharePayload } from '../../utils/documentSharePayload';
import { getSavedViewMode, saveViewMode } from '../../utils/viewPersistence';
import { canUploadDocuments } from '../../utils/documentAccess';
import { useDocumentAccess } from '../../hooks/useDocumentAccess';
import { useCanDo } from '../../hooks/useCanDo';
import { isValidDocumentField } from '../../utils/specialCharValidation';
import { buildQuerySuffix } from '../../utils/listQueryPersistence';
import Select from 'react-select';
import CategorizationIcon from './CategorizationIcon';

const DocumentList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { folderId } = useParams();
  const { hasAccess, loading: accessLoading } = useDocumentAccess();
  const canCreateDocuments = useCanDo('documents', 'create_edit');
  const canCreateClassifications = useCanDo('doc_classifications', 'create_edit');
  const canDeleteDocuments = useCanDo('documents', 'delete');
  const canShareDocuments = useCanDo('documents', 'share');
  const canDownloadDocuments = useCanDo('documents', 'download');
  const filterUrlSyncSkipRef = useRef(false);
  
  // Static data for folders and documents
  const [staticFolders, setStaticFolders] = useState([]);

  const [staticDocuments, setStaticDocuments] = useState([]);

  const [folders, setFolders] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(() => searchParams.get('search') || '');
  const [currentPath, setCurrentPath] = useState([]);
  const [currentFolderId, setCurrentFolderId] = useState(folderId ? parseInt(folderId) : null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteCheckData, setDeleteCheckData] = useState(null);
  const [showFirstDeleteModal, setShowFirstDeleteModal] = useState(false);
  const [showSecondDeleteModal, setShowSecondDeleteModal] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  // Share form state (separate from upload form)
  const [shareSelectedBranches, setShareSelectedBranches] = useState([]);
  const [shareSelectedDepartments, setShareSelectedDepartments] = useState([]);
  const [shareSelectedSubDepartments, setShareSelectedSubDepartments] = useState([]);
  const [shareSelectedUsers, setShareSelectedUsers] = useState([]);
  const [shareFilteredDepartments, setShareFilteredDepartments] = useState([]);
  const [shareFilteredSubDepartments, setShareFilteredSubDepartments] = useState([]);
  const [shareFilteredUsers, setShareFilteredUsers] = useState([]);
  const [sharing, setSharing] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [newButtonHovered, setNewButtonHovered] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // New document fields
  const [documentTitle, setDocumentTitle] = useState('');
  const [documentRegisteredTo, setDocumentRegisteredTo] = useState('');
  const [documentReferenceNumber, setDocumentReferenceNumber] = useState('');
  const [documentIssueDate, setDocumentIssueDate] = useState('');
  const [documentExpiryDate, setDocumentExpiryDate] = useState('');
  const [remindMeBefore, setRemindMeBefore] = useState('');
  const [documentIssuingAuthority, setDocumentIssuingAuthority] = useState('');
  const [otherComments, setOtherComments] = useState('');
  const [fieldErrors, setFieldErrors] = useState({
    documentTitle: '',
    documentRegisteredTo: '',
    documentReferenceNumber: '',
    documentIssuingAuthority: '',
    otherComments: ''
  });
  // Classification creation form state
  const [classificationFormData, setClassificationFormData] = useState({
    name: '',
    parent_id: null,
    fields: [{ id: Date.now(), fieldName: '', fieldType: '0' }]
  });
  const [availableClassificationsForParent, setAvailableClassificationsForParent] = useState([]);
  const [classificationFormErrors, setClassificationFormErrors] = useState({});
  const [loadingClassificationsForParent, setLoadingClassificationsForParent] = useState(false);
  const [prefillParentId, setPrefillParentId] = useState(null);
  const [documentClassifications, setDocumentClassifications] = useState([]);
  const [classificationsLoading, setClassificationsLoading] = useState(false);
  const [dynamicFields, setDynamicFields] = useState({});
  // File access fields
  const [isPrivate, setIsPrivate] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedSubDepartments, setSelectedSubDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [subDepartments, setSubDepartments] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [filteredSubDepartments, setFilteredSubDepartments] = useState([]);
  const [duplicateFiles, setDuplicateFiles] = useState([]);
  const [checkingDuplicates, setCheckingDuplicates] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateChoices, setDuplicateChoices] = useState({}); // { fileName: 'replace' | 'copy' }
  const [availableUsers, setAvailableUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [viewMode, setViewMode] = useState(() => getSavedViewMode('documentList', 'tile'));
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [sortBy, setSortBy] = useState(() => searchParams.get('sort') || 'updated_at');
  const [dropdownDirections, setDropdownDirections] = useState({});
  const [hasInitialLoad, setHasInitialLoad] = useState(false); // Track if initial data has been loaded
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 50,
    hasMore: false
  });
  const [loadingMore, setLoadingMore] = useState(false);
  const filterRef = useRef(null);

  // Handle click outside filter panel
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        // Check if the click is not on the filter button
        const filterButton = event.target.closest('button');
        if (filterButton && filterButton.textContent.includes('Filters')) {
          return; // Don't close if clicking the filter button
        }
        setShowFilterPanel(false);
      }
    };

    if (showFilterPanel) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterPanel]);

  // Force tile view on mobile screens
  useEffect(() => {
    const checkMobileView = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile && viewMode !== 'tile') {
        setViewMode('tile');
      }
    };

    // Check on mount
    checkMobileView();

    // Check on window resize
    window.addEventListener('resize', checkMobileView);

    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, [viewMode]);

  // Function to determine dropdown direction based on position
  const getDropdownDirection = (itemId, element) => {
    if (!element) return 'down';
    
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    const dropdownHeight = 250; // Approximate dropdown menu height
    
    // If not enough space below but enough space above, show dropdown up
    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      return 'up';
    }
    return 'down';
  };

  // Helper function to determine dropdown direction based on row index
  const getDropdownDirectionByIndex = (rowIndex, totalRows) => {
    // If table has 3 or fewer items, all open down
    if (totalRows <= 3) {
      return 'down';
    }
    
    // First two items (index 0, 1) open down
    if (rowIndex < 2) {
      return 'down';
    }
    
    // For tables with 6 or more items, last 4 items open up
    // For tables with 4-5 items, last 3 items open up
    let itemsToOpenUp = 3;
    if (totalRows >= 6) {
      itemsToOpenUp = 4;
    }
    
    const lastItemsStart = totalRows - itemsToOpenUp;
    if (rowIndex >= lastItemsStart) {
      return 'up';
    }
    
    // All other items open down
    return 'down';
  };

  // Handle dropdown toggle to check position
  const handleDropdownToggle = (itemId, isOpen, event, rowIndex = null, totalRows = null) => {
    if (!isOpen) return; // Only handle when opening
    
    // Use setTimeout to ensure DOM is ready
    setTimeout(() => {
      try {
        // Find the currently open dropdown menu - check both container classes
        const visibleDropdowns = document.querySelectorAll('.user-list-card .dropdown-menu.show, .document-drive-container .dropdown-menu.show, .table-row .dropdown-menu.show');
        
        if (visibleDropdowns.length === 0) {
          return; // No open dropdown found
        }
        
        // Get the most recently opened dropdown (last one in the list)
        const dropdownMenu = visibleDropdowns[visibleDropdowns.length - 1];
        const dropdown = dropdownMenu.closest('.dropdown');
        
        if (!dropdown) {
          return;
        }
        
        // Determine direction based on row index if available (for table view)
        let direction = 'down';
        if (rowIndex !== null && totalRows !== null) {
          direction = getDropdownDirectionByIndex(rowIndex, totalRows);
        } else {
          // Fallback to viewport-based logic for non-table views
          const toggleElement = dropdown.querySelector('.dropdown-toggle');
          
          if (toggleElement) {
            const rect = toggleElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const spaceBelow = viewportHeight - rect.bottom;
            const spaceAbove = rect.top;
            
            // Estimate dropdown menu height
            let estimatedDropdownHeight = 180;
            if (dropdownMenu.offsetHeight > 0) {
              estimatedDropdownHeight = dropdownMenu.offsetHeight;
            } else {
              const itemCount = dropdownMenu.querySelectorAll('.dropdown-item').length;
              estimatedDropdownHeight = Math.max(itemCount * 45, 150);
            }
            
            const minSpaceBelow = estimatedDropdownHeight + 50;
            const minSpaceAbove = estimatedDropdownHeight + 20;
            
            const shouldOpenAbove = spaceBelow < minSpaceBelow && 
                                    spaceAbove > (spaceBelow + 80) && 
                                    spaceAbove >= minSpaceAbove;
            
            direction = shouldOpenAbove ? 'up' : 'down';
          }
        }
        
        setDropdownDirections(prev => ({
          ...prev,
          [itemId]: direction
        }));
        
        // Check if this is a table dropdown
        const isTableDropdown = dropdown.closest('.table-row') || dropdown.closest('.tasks-table') || dropdown.closest('table');
        
        // Force left alignment for table dropdowns
        if (isTableDropdown) {
          dropdownMenu.style.right = '0';
          dropdownMenu.style.transform = 'none';
        }
        
        // Apply Bootstrap's dropup class if needed
        // For table dropdowns, apply direction immediately
        if (isTableDropdown && rowIndex !== null && totalRows !== null) {
          const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
          if (calculatedDirection === 'up') {
            dropdown.classList.add('dropup');
            direction = 'up';
          } else {
            dropdown.classList.remove('dropup');
            direction = 'down';
          }
        }
        
        if (direction === 'up') {
          dropdown.classList.add('dropup');
          // Add class to card and column to allow dropdown overflow
          const driveItem = dropdown.closest('.drive-item');
          const driveItemCol = dropdown.closest('.drive-item-col');
          const tableRow = dropdown.closest('.table-row');
          if (driveItem) driveItem.classList.add('dropdown-open');
          if (driveItemCol) driveItemCol.classList.add('dropdown-open');
          if (tableRow) tableRow.classList.add('dropdown-open');
          // Don't force styles - let Bootstrap handle it, but ensure it's visible
          setTimeout(() => {
            const menuRect = dropdownMenu.getBoundingClientRect();
            if (menuRect.top < 0) {
              // Menu is cut off at top, adjust
              const toggleElement = dropdown.querySelector('.dropdown-toggle');
              if (toggleElement) {
                const rect = toggleElement.getBoundingClientRect();
                const spaceAbove = rect.top;
                dropdownMenu.style.maxHeight = `${Math.max(spaceAbove - 5, 120)}px`;
                dropdownMenu.style.overflowY = 'auto';
              }
            }
            // Re-apply right alignment after Popper.js positioning
            if (isTableDropdown) {
              dropdownMenu.style.right = '0';
              dropdownMenu.style.left = 'auto';
              dropdownMenu.style.transform = 'none';
            }
            // Ensure dropup class is still applied
            if (isTableDropdown && rowIndex !== null && totalRows !== null) {
              const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
              if (calculatedDirection === 'up') {
                dropdown.classList.add('dropup');
              }
            }
          }, 50);
        } else {
          dropdown.classList.remove('dropup');
          // Add class to card and column to allow dropdown overflow
          const driveItem = dropdown.closest('.drive-item');
          const driveItemCol = dropdown.closest('.drive-item-col');
          const tableRow = dropdown.closest('.table-row');
          if (driveItem) driveItem.classList.add('dropdown-open');
          if (driveItemCol) driveItemCol.classList.add('dropdown-open');
          if (tableRow) tableRow.classList.add('dropdown-open');
          // Reset any max-height that might have been set
          dropdownMenu.style.maxHeight = '';
          dropdownMenu.style.overflowY = '';
          // Re-apply right alignment after Popper.js positioning
          if (isTableDropdown) {
            setTimeout(() => {
              dropdownMenu.style.right = '0';
              dropdownMenu.style.left = 'auto';
              dropdownMenu.style.transform = 'none';
              // Ensure dropup class is removed if it should be down
              if (rowIndex !== null && totalRows !== null) {
                const calculatedDirection = getDropdownDirectionByIndex(rowIndex, totalRows);
                if (calculatedDirection === 'down') {
                  dropdown.classList.remove('dropup');
                }
              }
            }, 10);
          }
        }
        
        // Remove the class when dropdown closes
        const removeOverflowClass = () => {
          const driveItem = dropdown.closest('.drive-item');
          const driveItemCol = dropdown.closest('.drive-item-col');
          const tableRow = dropdown.closest('.table-row');
          if (driveItem) driveItem.classList.remove('dropdown-open');
          if (driveItemCol) driveItemCol.classList.remove('dropdown-open');
          if (tableRow) tableRow.classList.remove('dropdown-open');
        };
        
        // Listen for dropdown close event
        dropdown.addEventListener('hidden.bs.dropdown', removeOverflowClass, { once: true });
      } catch (error) {
        console.error('Error in handleDropdownToggle:', error);
        // Fallback to default 'down' direction
        setDropdownDirections(prev => ({
          ...prev,
          [itemId]: 'down'
        }));
      }
    }, 10); // Small delay to ensure DOM is updated
  };
  
  // Filter state for document list
  const [filterClassification, setFilterClassification] = useState(null);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterDepartment, setFilterDepartment] = useState(null);
  const [filterSubDepartment, setFilterSubDepartment] = useState(null);
  const [filteredDepartmentsForFilter, setFilteredDepartmentsForFilter] = useState([]);
  const [filteredSubDepartmentsForFilter, setFilteredSubDepartmentsForFilter] = useState([]);
  
  // Pending filter states (not applied until user clicks Apply Filters)
  const [pendingFilterClassification, setPendingFilterClassification] = useState(null);
  const [pendingFilterBranch, setPendingFilterBranch] = useState(null);
  const [pendingFilterDepartment, setPendingFilterDepartment] = useState(null);
  const [pendingFilterSubDepartment, setPendingFilterSubDepartment] = useState(null);

  const getDocumentListQuerySuffix = () => buildQuerySuffix({
    search: searchTerm || undefined,
    sort: sortBy || undefined,
    cat: filterClassification?.value,
    branch: filterBranch?.value,
    dept: filterDepartment?.value,
    sub: filterSubDepartment?.value,
  });

  const commitDocumentListToUrl = () => {
    filterUrlSyncSkipRef.current = true;
    const suffix = getDocumentListQuerySuffix();
    setSearchParams(new URLSearchParams(suffix.replace(/^\?/, '')), { replace: true });
  };

  // Initialize pending filter states when filter panel opens
  useEffect(() => {
    if (showFilterPanel) {
      // Sync pending states with current filter states when panel opens
      setPendingFilterClassification(filterClassification);
      setPendingFilterBranch(filterBranch);
      setPendingFilterDepartment(filterDepartment);
      setPendingFilterSubDepartment(filterSubDepartment);
      
      // Ensure filtered departments/sub-departments are set correctly based on current filters
      if (filterBranch && departments.length > 0) {
        const filtered = departments.filter(dept => dept.branch_id === filterBranch.value);
        setFilteredDepartmentsForFilter(filtered);
        
        if (filterDepartment && subDepartments.length > 0) {
          const subs = subDepartments.filter(sd => {
            const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
            return sdDeptId === filterDepartment.value;
          });
          setFilteredSubDepartmentsForFilter(subs);
        } else if (subDepartments.length > 0) {
          const subs = subDepartments.filter(sd => {
            const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
            return filtered.some(d => d.id === sdDeptId);
          });
          setFilteredSubDepartmentsForFilter(subs);
        }
      } else if (departments.length > 0) {
        setFilteredDepartmentsForFilter(departments);
        if (subDepartments.length > 0) {
          setFilteredSubDepartmentsForFilter(subDepartments);
        }
      }
    }
  }, [showFilterPanel, filterClassification, filterBranch, filterDepartment, filterSubDepartment, departments, subDepartments]);

  const notifySuccess = (msg) => toast.success(`✔️ ${msg}`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
  });

  const notifyError = (msg) => toast.error(`❌ ${msg}`, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

  // Full breadcrumb: My Documents → … → current folder (fetch missing ancestors by id)
  const resolveFolderBreadcrumb = async (targetFolderId, foldersHint = null) => {
    if (!targetFolderId) {
      setCurrentPath([{ id: null, name: 'My Documents' }]);
      return;
    }

    const known = new Map();
    const seed = [
      ...(Array.isArray(foldersHint) ? foldersHint : []),
      ...staticFolders,
      ...folders,
    ];
    seed.forEach((f) => {
      if (f?.id != null) known.set(f.id, f);
    });

    const pathArray = [];
    const fetchedAncestors = [];
    let current = parseInt(targetFolderId, 10);
    const seen = new Set();

    while (current && !seen.has(current)) {
      seen.add(current);
      let folder = known.get(current);

      if (!folder) {
        try {
          const res = await axiosInstance.get(`/document-categories/${current}`);
          const category = res.data?.data || res.data;
          if (!category?.id) break;
          folder = {
            id: category.id,
            name: category.name,
            parent_id: category.parent_id ?? null,
          };
          known.set(folder.id, folder);
          fetchedAncestors.push(folder);
        } catch (err) {
          console.error('Error resolving folder breadcrumb ancestor:', err);
          break;
        }
      }

      if (!folder?.name || String(folder.name).trim() === '') break;
      pathArray.unshift({ id: folder.id, name: folder.name });
      current = folder.parent_id ? parseInt(folder.parent_id, 10) : null;
    }

    if (fetchedAncestors.length > 0) {
      setStaticFolders((prev) => {
        const next = [...prev];
        fetchedAncestors.forEach((f) => {
          const idx = next.findIndex((x) => x.id === f.id);
          if (idx >= 0) next[idx] = { ...next[idx], ...f };
          else next.push(f);
        });
        return next;
      });
    }

    setCurrentPath([{ id: null, name: 'My Documents' }, ...pathArray]);
  };

  useEffect(() => {
    if (folderId) {
      setCurrentFolderId(parseInt(folderId));
      setClassificationFormData({
        name: '',
        parent_id: folderId,
        fields: [{ id: Date.now(), fieldName: '', fieldType: '0' }]
      });
    } else {
      setCurrentFolderId(null);
    }
  }, [folderId]);

  useEffect(() => {
    // Reset initial load flag when folder changes to ensure search waits for new data
    setHasInitialLoad(false);
    // Reset to page 1 when folder or sort changes
    setPagination(prev => ({ ...prev, page: 1 }));
    loadDocuments(1);
    loadDocumentClassifications();
    fetchBranches();
    fetchDepartments();
    fetchSubDepartments();
    fetchUsers();
  }, [currentFolderId, sortBy]);

  // Rebuild full breadcrumb whenever the current folder changes (incl. Back from details)
  useEffect(() => {
    resolveFolderBreadcrumb(currentFolderId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFolderId]);

  // Sort folders: favorite classification folders first, then rest by sortBy option
  useEffect(() => {
    if (folders.length > 0 && documentClassifications.length > 0) {
      // Helper function to check if a folder is a favorite classification folder
      const isFavoriteClassificationFolder = (folder) => {
        // Check if folder has direct connection to classification
        if (folder.connection_type === 'category' && folder.connection_id) {
          const category = documentClassifications.find(cat => cat.id === folder.connection_id);
          return category?.is_favorite || false;
        }
        // Fallback: Try matching folder name to classification name
        if (folder.name) {
          const category = documentClassifications.find(cat => 
            cat.name.toLowerCase().trim() === folder.name.toLowerCase().trim()
          );
          return category?.is_favorite || false;
        }
        return false;
      };

      // Helper function to sort folders by sortBy option
      const sortByOption = (a, b) => {
        switch (sortBy) {
          case 'file_name':
            return (a.name || '').localeCompare(b.name || '');
          case 'created_at':
            const aCreated = new Date(a.created_at || 0);
            const bCreated = new Date(b.created_at || 0);
            return bCreated - aCreated; // Newest first
          case 'updated_at':
            const aUpdated = new Date(a.updated_at || a.created_at || 0);
            const bUpdated = new Date(b.updated_at || b.created_at || 0);
            return bUpdated - aUpdated; // Newest first
          default:
            return (a.name || '').localeCompare(b.name || '');
        }
      };
      
      const sortedFolders = [...folders].sort((a, b) => {
        const aIsFavorite = isFavoriteClassificationFolder(a);
        const bIsFavorite = isFavoriteClassificationFolder(b);
        
        // Favorite folders first
        if (aIsFavorite && !bIsFavorite) return -1;
        if (!aIsFavorite && bIsFavorite) return 1;
        
        // If both have same favorite status, sort by sortBy option
        return sortByOption(a, b);
      });
      
      // Only update if order actually changed (compare folder IDs)
      const currentFolderIds = folders.map(f => f.id).join(',');
      const sortedFolderIds = sortedFolders.map(f => f.id).join(',');
      
      if (currentFolderIds !== sortedFolderIds) {
        setFolders(sortedFolders);
      }
    }
  }, [folders, documentClassifications, sortBy]);

  // Sort documents: favorite documents first, then rest by sortBy option
  useEffect(() => {
    if (documents.length > 0) {
      // Helper function to sort documents by sortBy option
      const sortByOption = (a, b) => {
        switch (sortBy) {
          case 'file_name':
            const aName = (a.document_title || a.name || a.file_name || '').toLowerCase();
            const bName = (b.document_title || b.name || b.file_name || '').toLowerCase();
            return aName.localeCompare(bName);
          case 'created_at':
            const aCreated = new Date(a.created_at || 0);
            const bCreated = new Date(b.created_at || 0);
            return bCreated - aCreated; // Newest first
          case 'updated_at':
            const aUpdated = new Date(a.updated_at || a.created_at || 0);
            const bUpdated = new Date(b.updated_at || b.created_at || 0);
            return bUpdated - aUpdated; // Newest first
          case 'file_size':
            const aSize = parseFloat(a.file_size || 0);
            const bSize = parseFloat(b.file_size || 0);
            return bSize - aSize; // Largest first
          case 'file_type':
            const aType = (a.file_type || '').toLowerCase();
            const bType = (b.file_type || '').toLowerCase();
            return aType.localeCompare(bType);
          case 'expiry_date':
            const aExpiry = a.expiry_date ? new Date(a.expiry_date) : new Date(0);
            const bExpiry = b.expiry_date ? new Date(b.expiry_date) : new Date(0);
            // Sort by expiry date ascending (earliest expiry first)
            if (aExpiry.getTime() === 0 && bExpiry.getTime() === 0) return 0;
            if (aExpiry.getTime() === 0) return 1; // No expiry date goes to end
            if (bExpiry.getTime() === 0) return -1;
            return aExpiry - bExpiry;
          default:
            const defaultName = (a.document_title || a.name || a.file_name || '').toLowerCase();
            const defaultBName = (b.document_title || b.name || b.file_name || '').toLowerCase();
            return defaultName.localeCompare(defaultBName);
        }
      };

      const sortedDocuments = [...documents].sort((a, b) => {
        const aIsFavorite = a.is_favorite || false;
        const bIsFavorite = b.is_favorite || false;
        
        // Favorite documents first
        if (aIsFavorite && !bIsFavorite) return -1;
        if (!aIsFavorite && bIsFavorite) return 1;
        
        // If both have same favorite status, sort by sortBy option
        return sortByOption(a, b);
      });
      
      // Only update if order actually changed (compare document IDs)
      const currentDocIds = documents.map(d => d.id).join(',');
      const sortedDocIds = sortedDocuments.map(d => d.id).join(',');
      
      if (currentDocIds !== sortedDocIds) {
        setDocuments(sortedDocuments);
      }
    }
  }, [documents, sortBy]);

  // Reload documents when filters or search change (only after initial load)
  useEffect(() => {
    // Only reload if we have loaded the initial data (to avoid loading on mount)
    if (hasInitialLoad) {
      // Reset to page 1 when filters or search change
      setPagination(prev => ({ ...prev, page: 1 }));
      // Debounce search to avoid too many API calls
      const timeoutId = setTimeout(() => {
        commitDocumentListToUrl();
        loadDocuments(1);
      }, searchTerm ? 500 : 0); // 500ms delay for search, immediate for filters
      
      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterClassification, filterBranch, filterDepartment, filterSubDepartment, searchTerm, sortBy, hasInitialLoad]);

  // Hydrate org filters from URL once option lists are available
  useEffect(() => {
    const catId = searchParams.get('cat');
    const branchId = searchParams.get('branch');
    const deptId = searchParams.get('dept');
    const subId = searchParams.get('sub');
    if (!catId && !branchId && !deptId && !subId) return;

    if (catId && documentClassifications.length && !filterClassification) {
      const cat = documentClassifications.find((c) => String(c.id) === String(catId));
      if (cat) setFilterClassification({ value: cat.id, label: cat.name });
    }
    if (branchId && branches.length && !filterBranch) {
      const branch = branches.find((b) => String(b.id) === String(branchId));
      if (branch) setFilterBranch({ value: branch.id, label: branch.name || branch.branch_name });
    }
    if (deptId && departments.length && !filterDepartment) {
      const dept = departments.find((d) => String(d.id) === String(deptId));
      if (dept) setFilterDepartment({ value: dept.id, label: dept.name || dept.department_name });
    }
    if (subId && subDepartments.length && !filterSubDepartment) {
      const sub = subDepartments.find((s) => String(s.id) === String(subId));
      if (sub) {
        setFilterSubDepartment({
          value: sub.id,
          label: sub.name || sub.sub_department_name || sub.subDepartmentName,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentClassifications, branches, departments, subDepartments, searchParams]);

  // Restore search/sort from URL when returning via history / Back
  useEffect(() => {
    if (filterUrlSyncSkipRef.current) {
      filterUrlSyncSkipRef.current = false;
      return;
    }
    const nextSearch = searchParams.get('search') || '';
    const nextSort = searchParams.get('sort') || 'updated_at';
    if (nextSearch !== searchTerm) setSearchTerm(nextSearch);
    if (nextSort !== sortBy) setSortBy(nextSort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Initialize filter department/sub-department lists
  useEffect(() => {
    if (departments.length > 0) {
      setFilteredDepartmentsForFilter(departments);
    }
    if (subDepartments.length > 0) {
      setFilteredSubDepartmentsForFilter(subDepartments);
    }
  }, [departments, subDepartments]);

  const loadDocumentClassifications = async () => {
    setClassificationsLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const response = await axiosInstance.get(`/document-categories?corporate_id=${corporateId}`);
      const data = response.data;
      
      if (response.status === 200) {
        // Handle response structure: { success: true, data: [...] }
        const classifications = data.success ? data.data : (data.data || data || []);
        setDocumentClassifications(classifications);
      }
    } catch (error) {
      console.error("Error fetching document classifications:", error);
      notifyError('Failed to fetch document classifications');
    } finally {
      setClassificationsLoading(false);
    }
  };

  const fetchBranches = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const res = await axiosInstance.get(`/settings/branches?corporate_id=${corporateId}`);
      const data = res.data;
      
      if (res) {
        setBranches(data.data || data || []);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      const res = await axiosInstance.get(`/settings/departments?corporate_id=${corporateId}`);
      const data = res.data;
      
      if (res) {
        const deptList = data.data || data || [];
        setDepartments(deptList);
        setFilteredDepartments(deptList);
      }
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

  const fetchSubDepartments = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      let res;
      try {
        res = await axiosInstance.get(`/settings/subDepartments?corporate_id=${corporateId}`);
      } catch (e1) {
        res = await axiosInstance.get(`/settings/subdepartments?corporate_id=${corporateId}`);
      }
      const data = res.data;
      
      if (res) {
        const subDeptList = data.data || data || [];
        setSubDepartments(subDeptList);
        setFilteredSubDepartments(subDeptList);
      }
    } catch (error) {
      console.error('Error fetching sub-departments:', error);
    }
  };

  // Handle branch change - filter departments
  const handleBranchChange = async (branchIds, selectedOptions) => {
    setSelectedBranches(branchIds);
    
    if (branchIds.length > 0) {
      // Filter departments based on selected branches
      const filtered = departments.filter(dept => branchIds.includes(dept.branch_id));
      setFilteredDepartments(filtered);
      
      // Keep only valid departments
      const validDepartmentIds = selectedDepartments.filter(deptId => {
        return filtered.some(d => d.id === deptId);
      });
      setSelectedDepartments(validDepartmentIds);
      
      // Filter sub-departments based on valid departments
      // If departments are selected, filter by those departments
      // If no departments selected but branches are selected, filter by all departments in those branches
      let subs = [];
      if (validDepartmentIds.length > 0) {
        // Departments are selected - filter sub-departments by those departments
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return validDepartmentIds.includes(sdDeptId);
        });
      } else {
        // No departments selected, but branches are - show sub-departments from all departments in selected branches
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          // Check if this sub-department's department belongs to one of the selected branches
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && branchIds.includes(dept.branch_id);
        });
      }
      setFilteredSubDepartments(subs);
      
      // Keep only valid sub-departments
      const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setSelectedSubDepartments(validSubDepartmentIds);
      
      // Filter users based on selected branches, departments, and sub-departments
      await filterUsersBySelections(branchIds, validDepartmentIds, validSubDepartmentIds);
    } else {
      // Reset to all departments
      setFilteredDepartments(departments);
      
      // If departments are still selected, filter sub-departments by those departments
      if (selectedDepartments.length > 0) {
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return selectedDepartments.includes(sdDeptId);
        });
        setFilteredSubDepartments(subs);
        
        // Keep only valid sub-departments
        const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setSelectedSubDepartments(validSubDepartmentIds);
        
        // Filter users by selected departments and sub-departments
        await filterUsersBySelections([], selectedDepartments, validSubDepartmentIds);
      } else {
        // No departments selected either - show all sub-departments
        setFilteredSubDepartments(subDepartments);
        // Show all users when no filters
        setFilteredUsers(availableUsers);
      }
    }
  };

  // Handle department change - filter sub-departments
  const handleDepartmentChange = async (departmentIds, selectedOptions) => {
    setSelectedDepartments(departmentIds);
    
    if (departmentIds.length > 0) {
      // Filter sub-departments based on selected departments
      // Check multiple possible field names for department_id
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        // First filter by department_id - must match one of the selected departments
        return departmentIds.includes(sdDeptId);
      });
      
      // If branches are also selected, further filter to ensure departments belong to selected branches
      if (selectedBranches.length > 0) {
        subs = subs.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          // Only include if the department belongs to one of the selected branches
          return dept && selectedBranches.includes(dept.branch_id);
        });
      }
      
      setFilteredSubDepartments(subs);
      
      // Keep only valid sub-departments
      const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setSelectedSubDepartments(validSubDepartmentIds);
      
      // Filter users based on selected branches, departments, and sub-departments
      await filterUsersBySelections(selectedBranches, departmentIds, validSubDepartmentIds);
    } else {
      // Reset to all sub-departments based on branches (if any)
      if (selectedBranches.length > 0) {
        // If branches are selected but no departments, show sub-departments from all departments in those branches
        const filtered = departments.filter(dept => selectedBranches.includes(dept.branch_id));
        const filteredDeptIds = filtered.map(d => d.id);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filteredDeptIds.includes(sdDeptId);
        });
        setFilteredSubDepartments(subs);
        
        // Keep only valid sub-departments
        const validSubDepartmentIds = selectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setSelectedSubDepartments(validSubDepartmentIds);
        
        // Filter users based on branches and valid sub-departments
        await filterUsersBySelections(selectedBranches, [], validSubDepartmentIds);
      } else {
        // No branches selected - show all sub-departments
        setFilteredSubDepartments(subDepartments);
        // Show all users when no filters
        setFilteredUsers(availableUsers);
        setSelectedSubDepartments([]);
      }
    }
  };

  // Handle sub-department change - filter users
  const handleSubDepartmentChange = async (subDepartmentIds, selectedOptions) => {
    setSelectedSubDepartments(subDepartmentIds);
    
    // Filter users based on selected branches, departments, and sub-departments
    await filterUsersBySelections(selectedBranches, selectedDepartments, subDepartmentIds);
  };

  // Function to fetch users by filters (similar to TaskForm)
  const fetchUsersByFilters = async (branchIds, departmentIds, subDepartmentIds) => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      if (!corporateId) return [];
      
      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));
      
      // Add branch filters - use comma-separated values
      if (branchIds && branchIds.length > 0) {
        params.append('branch', branchIds.join(','));
      }
      
      // Add department filters - use comma-separated values
      if (departmentIds && departmentIds.length > 0) {
        params.append('department', departmentIds.join(','));
      }
      
      // Add sub-department filters - use comma-separated values
      if (subDepartmentIds && subDepartmentIds.length > 0) {
        params.append('sub_department', subDepartmentIds.join(','));
      }

      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];
      
      // Filter out the currently logged-in user
      const filteredUsers = users.filter(user => user.id !== userData.id);
      
      return filteredUsers;
    } catch (error) {
      console.error('Error fetching users by filters:', error);
      return [];
    }
  };

  // Filter users based on selected branches, departments, and sub-departments
  const filterUsersBySelections = async (branchIds, departmentIds, subDepartmentIds) => {
    if (branchIds.length > 0 || departmentIds.length > 0 || subDepartmentIds.length > 0) {
      // Fetch users from API with filters
      const users = await fetchUsersByFilters(branchIds, departmentIds, subDepartmentIds);
      setFilteredUsers(users);
      
      // Remove invalid users from selection
      if (selectedUsers.length > 0) {
        const validUserIds = selectedUsers.filter(userId => 
          users.some(user => {
            const userIdMatch = user.id === userId || user.CorporateUserId === userId;
            return userIdMatch;
          })
        );
        if (validUserIds.length !== selectedUsers.length) {
          setSelectedUsers(validUserIds);
        }
      }
    } else {
      // No filters, show all available users
      setFilteredUsers(availableUsers);
    }
  };

  // Fetch users for user selection
  const fetchUsers = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      if (!corporateId) return;
      
      const params = new URLSearchParams();
      params.append('corporateId', parseInt(corporateId));
      
      // Removed branch and department filters from initial call to show all corporate users

      const response = await axiosInstance.get(`/list/corporateuserslist?${params.toString()}`);
      const users = response.data.users || [];

      // Filter out the currently logged-in user
      const filteredUsers = users.filter(user => user.id !== userData.id);

      setAvailableUsers(filteredUsers);
      setFilteredUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Handle user change
  const handleUserChange = (userIds, selectedOptions) => {
    setSelectedUsers(userIds);
  };

  // Share form handlers (separate from upload form)
  const handleShareBranchChange = async (branchIds, selectedOptions) => {
    setShareSelectedBranches(branchIds);
    
    if (branchIds.length > 0) {
      const filtered = departments.filter(dept => branchIds.includes(dept.branch_id));
      setShareFilteredDepartments(filtered);
      
      const validDepartmentIds = shareSelectedDepartments.filter(deptId => {
        return filtered.some(d => d.id === deptId);
      });
      setShareSelectedDepartments(validDepartmentIds);
      
      let subs = [];
      if (validDepartmentIds.length > 0) {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return validDepartmentIds.includes(sdDeptId);
        });
      } else {
        subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && branchIds.includes(dept.branch_id);
        });
      }
      setShareFilteredSubDepartments(subs);
      
      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);
      
      await filterShareUsersBySelections(branchIds, validDepartmentIds, validSubDepartmentIds);
    } else {
      setShareFilteredDepartments(departments);
      
      if (shareSelectedDepartments.length > 0) {
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return shareSelectedDepartments.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);
        
        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);
        
        await filterShareUsersBySelections([], shareSelectedDepartments, validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(availableUsers);
      }
    }
  };

  const handleShareDepartmentChange = async (departmentIds, selectedOptions) => {
    setShareSelectedDepartments(departmentIds);
    
    if (departmentIds.length > 0) {
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        return departmentIds.includes(sdDeptId);
      });
      
      if (shareSelectedBranches.length > 0) {
        subs = subs.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          const dept = departments.find(d => d.id === sdDeptId);
          return dept && shareSelectedBranches.includes(dept.branch_id);
        });
      }
      
      setShareFilteredSubDepartments(subs);
      
      const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
        return subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === subDeptId;
        });
      });
      setShareSelectedSubDepartments(validSubDepartmentIds);
      
      await filterShareUsersBySelections(shareSelectedBranches, departmentIds, validSubDepartmentIds);
    } else {
      if (shareSelectedBranches.length > 0) {
        const filtered = departments.filter(dept => shareSelectedBranches.includes(dept.branch_id));
        const filteredDeptIds = filtered.map(d => d.id);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filteredDeptIds.includes(sdDeptId);
        });
        setShareFilteredSubDepartments(subs);
        
        const validSubDepartmentIds = shareSelectedSubDepartments.filter(subDeptId => {
          return subs.some(sd => {
            const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
            return sdId === subDeptId;
          });
        });
        setShareSelectedSubDepartments(validSubDepartmentIds);
        
        await filterShareUsersBySelections(shareSelectedBranches, [], validSubDepartmentIds);
      } else {
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(availableUsers);
        setShareSelectedSubDepartments([]);
      }
    }
  };

  const handleShareSubDepartmentChange = async (subDepartmentIds, selectedOptions) => {
    setShareSelectedSubDepartments(subDepartmentIds);
    await filterShareUsersBySelections(shareSelectedBranches, shareSelectedDepartments, subDepartmentIds);
  };

  const filterShareUsersBySelections = async (branchIds, departmentIds, subDepartmentIds) => {
    if (branchIds.length > 0 || departmentIds.length > 0 || subDepartmentIds.length > 0) {
      const users = await fetchUsersByFilters(branchIds, departmentIds, subDepartmentIds);
      setShareFilteredUsers(users);
      
      if (shareSelectedUsers.length > 0) {
        const validUserIds = shareSelectedUsers.filter(userId => 
          users.some(user => {
            const userIdMatch = user.id === userId || user.CorporateUserId === userId;
            return userIdMatch;
          })
        );
        if (validUserIds.length !== shareSelectedUsers.length) {
          setShareSelectedUsers(validUserIds);
        }
      }
    } else {
      setShareFilteredUsers(availableUsers);
    }
  };

  const handleShareUserChange = (userIds, selectedOptions) => {
    setShareSelectedUsers(userIds);
  };

  // Handle share document (internal)
  const handleShareDocument = async () => {
    if (!selectedItem || !selectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);
      
      const payload = buildDocumentSharePayload(
        shareSelectedBranches,
        shareSelectedDepartments,
        shareSelectedSubDepartments,
        shareSelectedUsers
      );

      const response = await axiosInstance.put(`/documents/${selectedItem.id}/share`, payload);

      if (response.status === 200) {
        notifySuccess('Document shared successfully');
        setShowShareModal(false);
        // Reset form
        setShareSelectedBranches([]);
        setShareSelectedDepartments([]);
        setShareSelectedSubDepartments([]);
        setShareSelectedUsers([]);
        setShareFilteredDepartments(departments);
        setShareFilteredSubDepartments(subDepartments);
        setShareFilteredUsers(availableUsers);
        setSelectedItem(null);
        // Refresh documents
        // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
      }
    } catch (error) {
      console.error('Error sharing document:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to share document';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Handle email share document
  const handleEmailShareDocument = async (payload) => {
    if (!selectedItem || !selectedItem.id) {
      notifyError('Invalid document');
      return;
    }

    try {
      setSharing(true);
      
      const requestPayload = {
        fileId: selectedItem.id,
        email: payload.email,
        permission: 'view',
        expiryOption: payload.expiryOption || 'never'
      };

      const response = await axiosInstance.post('/share', requestPayload);

      if (response.status === 200 || response.status === 201) {
        notifySuccess('Document shared via email successfully');
        setShowShareModal(false);
        setSelectedItem(null);
        // Refresh documents
        // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
      }
    } catch (error) {
      console.error('Error sharing document via email:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to share document via email';
      notifyError(errorMessage);
    } finally {
      setSharing(false);
    }
  };

  // Reset share form
  const resetShareForm = () => {
    setShareSelectedBranches([]);
    setShareSelectedDepartments([]);
    setShareSelectedSubDepartments([]);
    setShareSelectedUsers([]);
    setShareFilteredDepartments(departments);
    setShareFilteredSubDepartments(subDepartments);
    setShareFilteredUsers(availableUsers);
    setSelectedItem(null);
  };

  // Initialize filtered users when availableUsers changes (but only if no filters are set)
  useEffect(() => {
    if (availableUsers.length > 0) {
      // Only auto-set if no filters are currently selected
      if (selectedBranches.length === 0 && selectedDepartments.length === 0 && selectedSubDepartments.length === 0) {
        setFilteredUsers(availableUsers);
      }
    }
  }, [availableUsers]);

  const loadDocuments = async (page = 1, append = false) => {
    // Prevent multiple simultaneous calls
    if (loading || loadingMore) return;
    
    if (page === 1) {
      setLoading(true);
    } else {
      setLoadingMore(true);
    }
    
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Build query parameters
      const params = new URLSearchParams();
      params.append('corporate_id', corporateId);
      
      // Add pagination parameters
      params.append('page', page);
      params.append('limit', pagination.limit);
      
      if (currentFolderId) {
        params.append('parent_id', currentFolderId);
      }
      
      // Apply filters via API
      if (filterClassification) {
        params.append('category_id', filterClassification.value);
      }
      
      if (filterBranch) {
        params.append('branch_id', filterBranch.value);
      }
      
      if (filterDepartment) {
        params.append('department_id', filterDepartment.value);
      }
      
      if (filterSubDepartment) {
        const subDeptId = filterSubDepartment.value;
        params.append('sub_department_id', subDeptId);
      }
      
      // Apply search term via API
      if (searchTerm && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
      }
      
      // Apply sorting via API
      if (sortBy) {
        params.append('sort_by', sortBy);
      }
      
      const response = await axiosInstance.get(`/documents/list?${params.toString()}`);
      const data = response.data;
      
      if (response.status === 200 && data.success) {
        const responseData = data.data;
        
        // Extract folders and documents from response
        const fetchedFolders = responseData.folders || [];
        const fetchedDocuments = responseData.documents || [];
        
        // Store pagination information
        if (responseData.pagination) {
          setPagination(responseData.pagination);
        }
        
        // Helper function to flatten folder tree (extract all folders including children)
        const flattenFolderTree = (folderTree) => {
          let allFolders = [];
          
          const traverse = (folders) => {
            folders.forEach(folder => {
              // Add current folder (without children for display)
              const { children, ...folderWithoutChildren } = folder;
              allFolders.push(folderWithoutChildren);
              
              // Recursively process children
              if (folder.children && folder.children.length > 0) {
                traverse(folder.children);
              }
            });
          };
          
          traverse(folderTree);
          return allFolders;
        };
        
        // Flatten folder tree to get all folders for path building
        const allFolders = flattenFolderTree(fetchedFolders);
        
        // Merge with existing staticFolders to preserve parent folders for path building
        // This ensures we always have all folders needed to build the full path
        const mergedFolders = [...staticFolders];
        
        // Add current folder if we're in a folder (API might not return it)
        if (currentFolderId) {
          const currentFolderExists = mergedFolders.find(f => f.id === currentFolderId);
          if (!currentFolderExists) {
            // Try to find it in displayFolders or fetch it
            // For now, we'll add it from the folders we have or from the API response
            const currentFolderFromResponse = allFolders.find(f => f.id === currentFolderId);
            if (currentFolderFromResponse) {
              mergedFolders.push(currentFolderFromResponse);
            }
          }
        }
        
        allFolders.forEach(newFolder => {
          const existingIndex = mergedFolders.findIndex(f => f.id === newFolder.id);
          if (existingIndex >= 0) {
            // Update existing folder with latest data
            mergedFolders[existingIndex] = { ...mergedFolders[existingIndex], ...newFolder };
          } else {
            // Add new folder
            mergedFolders.push(newFolder);
          }
        });
        
        // For display, use the folders directly from API (already filtered by parent_id)
        // The API returns folders for the current level only
        const displayFolders = fetchedFolders.map(folder => ({
          id: folder.id,
          name: folder.name,
          type: 'folder',
          parent_id: folder.parent_id,
          corporate_id: folder.corporate_id,
          connection_type: folder.connection_type,
          connection_id: folder.connection_id,
          created_at: folder.created_at,
          is_favorite: folder.is_favorite || false,
          // Keep children for potential future use (like expandable tree view)
          children: folder.children || [],
          created_by_name: folder.created_by?.full_name || folder.created_by_name || null
        }));
        
        // Format documents to match expected structure
        const formattedDocuments = fetchedDocuments.map(doc => ({
          id: doc.id,
          name: doc.name || doc.file_name,
          file_name: doc.name || doc.file_name,
          type: 'file',
          folder_id: doc.document_path_id,
          document_path_id: doc.document_path_id,
          file_size: doc.file_size,
          size: doc.file_size ? `${(parseFloat(doc.file_size) / 1024 / 1024).toFixed(2)} MB` : '0 MB',
          file_type: doc.file_type,
          version: doc.version,
          is_private: doc.is_private,
          is_favorite: doc.is_favorite || false,
          category_id: doc.category?.id || doc.category_id || null,
          category_name: doc.category?.name || doc.category_name || null,
          category: doc.category || null,
          // New document fields
          document_title: doc.document_title || null,
          registered_to: doc.registered_to || null,
          reference_number: doc.reference_number || null,
          issue_date: doc.issue_date || null,
          expiry_date: doc.expiry_date || null,
          remind_before: doc.remind_before || null,
          issuing_authority: doc.issuing_authority || null,
          other_comments: doc.other_comments || null,
          // Uploaded by information
          uploaded_by: doc.uploaded_by || null,
          uploaded_by_id: doc.uploaded_by_id || null,
          uploaded_by_name: doc.uploaded_by?.full_name || null,
          branches: doc.branches || [],
          departments: doc.departments || [],
          sub_departments: doc.sub_departments || [],
          created_at: doc.created_at,
          updated_at: doc.updated_at
        }));
        
        // Update static data - merge folders to preserve parent folders
        setStaticFolders(mergedFolders);
        setStaticDocuments(formattedDocuments);
        
        // Set folders and documents for display (already filtered by API)
        // Sorting by favorite will happen in useEffect after classifications are loaded
        if (append) {
          // Append new documents when loading more pages
          setDocuments(prev => [...prev, ...formattedDocuments]);
        } else {
          // Replace with new documents when loading first page or filtering
          setFolders(displayFolders);
          setDocuments(formattedDocuments);
          
          // Rebuild full breadcrumb (ancestors may be missing from this level's response)
          if (currentFolderId) {
            resolveFolderBreadcrumb(currentFolderId, mergedFolders);
          }
        }
        
        // Mark initial load as complete
        setHasInitialLoad(true);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      notifyError(error.response?.data?.message || 'Failed to load documents');
      // Keep existing data on error
      // Still mark as loaded to allow search even if initial load fails
      setHasInitialLoad(true);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleFolderClick = (folder) => {
    // Ensure the clicked folder is in staticFolders for path building
    setStaticFolders(prev => {
      const exists = prev.find(f => f.id === folder.id);
      if (!exists) {
        return [...prev, {
          id: folder.id,
          name: folder.name,
          parent_id: folder.parent_id,
          corporate_id: folder.corporate_id,
          connection_type: folder.connection_type,
          connection_id: folder.connection_id,
          created_at: folder.created_at
        }];
      }
      return prev;
    });
    setCurrentFolderId(folder.id);
    navigate(`/documents/folder/${folder.id}`);
  };

  const handlePathClick = (folder) => {
    if (!folder.id) {
      setCurrentFolderId(null);
      navigate('/documents/mydocuments');
    } else {
      setCurrentFolderId(folder.id);
      navigate(`/documents/folder/${folder.id}`);
    }
  };

  // Generate unique filename by appending timestamp
  const generateUniqueFileName = (originalFileName) => {
    const fileExtension = originalFileName.split('.').pop();
    const fileNameWithoutExt = originalFileName.substring(0, originalFileName.lastIndexOf('.'));
    const timestamp = Date.now();
    const randomId = Math.random().toString(36).substring(2, 8); // 6 character random ID
    return `${fileNameWithoutExt}_${timestamp}_${randomId}.${fileExtension}`;
  };

  // Check for duplicate files
  const checkDuplicates = async (files) => {
    if (!files || files.length === 0) return [];
    
    setCheckingDuplicates(true);
    const duplicateResults = [];
    
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Check each file for duplicates
      const checkPromises = files.map(async (file) => {
        try {
          const payload = {
            file_name: file.name,
            document_path_id: currentFolderId || null,
            corporation_id: corporateId,
            branch_id: selectedBranches.length > 0 ? selectedBranches[0] : null,
            department_id: selectedDepartments.length > 0 ? selectedDepartments[0] : null,
            subdepartment_id: selectedSubDepartments.length > 0 ? selectedSubDepartments[0] : null
          };
          
          const response = await axiosInstance.post('/documents/check-duplicate', payload);
          const data = response.data;
          
          if (data.isDuplicate) {
            return {
              file: file,
              isDuplicate: true,
              duplicateData: data.data
            };
          }
          
          return {
            file: file,
            isDuplicate: false
          };
        } catch (error) {
          console.error(`Error checking duplicate for ${file.name}:`, error);
          // If check fails, assume no duplicate (allow upload)
          return {
            file: file,
            isDuplicate: false,
            error: true
          };
        }
      });
      
      const results = await Promise.all(checkPromises);
      duplicateResults.push(...results.filter(r => r.isDuplicate));
      
      return duplicateResults;
    } catch (error) {
      console.error('Error checking duplicates:', error);
      return [];
    } finally {
      setCheckingDuplicates(false);
    }
  };

  // Process files based on user choices for duplicates
  const processFilesWithChoices = (files, duplicateChoices) => {
    return files.map((file) => {
      const choice = duplicateChoices[file.name];
      
      if (choice === 'replace') {
        // Use original name (will replace existing file)
        return {
          originalFile: file,
          processedFile: file,
          originalName: file.name,
          newName: file.name,
          wasRenamed: false,
          action: 'replace'
        };
      } else if (choice === 'copy') {
        // Generate unique filename (keep as copy)
        const newFileName = generateUniqueFileName(file.name);
        const renamedFile = new File([file], newFileName, {
          type: file.type,
          lastModified: file.lastModified
        });
        
        return {
          originalFile: file,
          processedFile: renamedFile,
          originalName: file.name,
          newName: newFileName,
          wasRenamed: true,
          action: 'copy'
        };
      }
      
      // No duplicate or no choice made yet - use original
      return {
        originalFile: file,
        processedFile: file,
        originalName: file.name,
        newName: file.name,
        wasRenamed: false,
        action: null
      };
    });
  };

  const handleFileUpload = async () => {
    if (uploadFiles.length === 0) {
      notifyError('Please select files to upload');
      return;
    }

    // Check storage space before upload
    const totalFileSize = uploadFiles.reduce((sum, file) => sum + (file.size || 0), 0);
    const accessCheck = await canUploadDocuments(totalFileSize);
    
    if (!accessCheck.canUpload) {
      if (accessCheck.reason === 'insufficient_space') {
        notifyError(accessCheck.message || 'Insufficient storage space to upload these files');
      } else {
        notifyError(accessCheck.message || 'You do not have permission to upload documents');
      }
      return;
    }

    // Validate document title and special character validation
    let hasError = false;
    const newErrors = { documentTitle: '', documentRegisteredTo: '', documentReferenceNumber: '', documentIssuingAuthority: '', otherComments: '' };
    if (!documentTitle || documentTitle.trim() === '') {
      newErrors.documentTitle = 'Document Title is required';
      hasError = true;
    } else if (!isValidDocumentField(documentTitle)) {
      newErrors.documentTitle = 'Document title cannot contain only special characters.';
      hasError = true;
    }
    if (documentRegisteredTo.trim() && !isValidDocumentField(documentRegisteredTo)) {
      newErrors.documentRegisteredTo = 'Cannot contain only special characters.';
      hasError = true;
    }
    if (documentReferenceNumber.trim() && !isValidDocumentField(documentReferenceNumber)) {
      newErrors.documentReferenceNumber = 'Cannot contain only special characters.';
      hasError = true;
    }
    if (documentIssuingAuthority.trim() && !isValidDocumentField(documentIssuingAuthority)) {
      newErrors.documentIssuingAuthority = 'Cannot contain only special characters.';
      hasError = true;
    }
    if (otherComments.trim() && !isValidDocumentField(otherComments)) {
      newErrors.otherComments = 'Cannot contain only special characters.';
      hasError = true;
    }
    if (hasError) {
      setFieldErrors(newErrors);
      return;
    }

    // Validate required dynamic fields only if a classification is selected
    if (selectedCategory) {
      const selectedCategoryData = documentClassifications.find(cat => cat.id === selectedCategory);
      if (selectedCategoryData && selectedCategoryData.fields) {
        const requiredFields = selectedCategoryData.fields.filter(field => field.is_required);
        const missingFields = requiredFields.filter(field => {
          const fieldValue = dynamicFields[field.id];
          return !fieldValue || fieldValue.trim() === '';
        });
        
        if (missingFields.length > 0) {
          notifyError(`Please fill in all required fields: ${missingFields.map(f => f.field_name).join(', ')}`);
          return;
        }
      }
    }

    // Check for duplicates
    const duplicates = await checkDuplicates(uploadFiles);
    
    // If duplicates found, show modal for user to choose
    if (duplicates.length > 0) {
      setDuplicateFiles(duplicates);
      // Initialize choices with default 'copy' for all duplicates
      const initialChoices = {};
      duplicates.forEach(dup => {
        initialChoices[dup.file.name] = 'copy'; // Default to 'copy'
      });
      setDuplicateChoices(initialChoices);
      setShowDuplicateModal(true);
      return; // Wait for user to make choices
    }

    // No duplicates, proceed with upload
    proceedWithUpload(uploadFiles, {});
  };

  // Proceed with upload after user makes duplicate choices
  const proceedWithUpload = async (files, choices) => {
    setLoading(true);
    
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Process files based on user choices
      const processedFiles = processFilesWithChoices(files, choices);
      
      // Upload each file
      const uploadPromises = processedFiles.map(async (fileInfo) => {
        try {
          const formData = new FormData();
          
          // Required fields
          formData.append('file', fileInfo.processedFile);
          formData.append('corporation_id', corporateId);
          
          // New document fields
          if (documentTitle) {
            formData.append('document_title', documentTitle);
          }
          if (documentRegisteredTo) {
            formData.append('registered_to', documentRegisteredTo);
          }
          if (documentReferenceNumber) {
            formData.append('reference_number', documentReferenceNumber);
          }
          if (documentIssueDate) {
            formData.append('issue_date', documentIssueDate);
          }
          if (documentExpiryDate) {
            formData.append('expiry_date', documentExpiryDate);
          }
          if (remindMeBefore) {
            formData.append('remind_before', remindMeBefore);
          }
          if (documentIssuingAuthority) {
            formData.append('issuing_authority', documentIssuingAuthority);
          }
          if (otherComments) {
            formData.append('other_comments', otherComments);
          }
          
          // Optional fields
          if (fileInfo.action) {
            // Use user's choice for duplicate_action
            formData.append('duplicate_action', fileInfo.action);
          } else {
            // Default to 'copy' if no duplicate was found
            formData.append('duplicate_action', 'copy');
          }
          
          if (currentFolderId) {
            formData.append('document_path_id', currentFolderId);
          }
          
          if (selectedCategory) {
            formData.append('category_id', selectedCategory);
          }
          
          if (Object.keys(dynamicFields).length > 0) {
            formData.append('field_values', JSON.stringify(dynamicFields));
          }
          
          if (isPrivate) {
            formData.append('is_private', isPrivate);
          }
          
          if (selectedBranches.length > 0) {
            formData.append('branch_ids', JSON.stringify(selectedBranches));
          }
          
          if (selectedDepartments.length > 0) {
            formData.append('department_ids', JSON.stringify(selectedDepartments));
          }
          
          if (selectedSubDepartments.length > 0) {
            formData.append('sub_department_ids', JSON.stringify(selectedSubDepartments));
          }
          
          if (selectedUsers.length > 0) {
            formData.append('user_ids', JSON.stringify(selectedUsers));
          }
          
          // Upload file
          const response = await axiosInstance.post('/documents/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          
          return {
            success: true,
            fileInfo: fileInfo,
            response: response.data
          };
        } catch (error) {
          console.error(`Error uploading ${fileInfo.originalName}:`, error);
          return {
            success: false,
            fileInfo: fileInfo,
            error: error.response?.data || error.message
          };
        }
      });
      
      const results = await Promise.all(uploadPromises);
      
      // Check for failures
      const failures = results.filter(r => !r.success);
      const successes = results.filter(r => r.success);
      
      if (failures.length > 0) {
        const failedNames = failures.map(f => f.fileInfo.originalName).join(', ');
        notifyError(`Failed to upload: ${failedNames}`);
      }
      
      if (successes.length > 0) {
        // Show success message with rename info if any files were renamed
        const renamedCount = processedFiles.filter(f => f.wasRenamed).length;
        const replacedCount = processedFiles.filter(f => f.action === 'replace').length;
        
        if (renamedCount > 0) {
          const renamedNames = processedFiles
            .filter(f => f.wasRenamed)
            .map(f => `${f.originalName} → ${f.newName}`)
            .join(', ');
          notifySuccess(`${renamedCount} file(s) saved as copy: ${renamedNames}`);
        }
        
        if (replacedCount > 0) {
          notifySuccess(`${replacedCount} file(s) replaced existing file(s)`);
        }
        
        if (renamedCount === 0 && replacedCount === 0) {
          notifySuccess(`${successes.length} file(s) uploaded successfully`);
        }
        
        // Reload documents from API to get updated list
        // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
      }
      
      // Reset form and close modals
      setShowUploadModal(false);
      setShowDuplicateModal(false);
      setUploadFiles([]);
      setSelectedCategory(null);
      setDynamicFields({});
      setIsPrivate(false);
      setSelectedBranches([]);
      setSelectedDepartments([]);
      setSelectedSubDepartments([]);
      setFilteredDepartments(departments);
      setFilteredSubDepartments(subDepartments);
      setDuplicateFiles([]);
      setDuplicateChoices({});
      // Reset new document fields
      setDocumentTitle('');
      setDocumentRegisteredTo('');
      setDocumentReferenceNumber('');
      setDocumentIssueDate('');
      setDocumentExpiryDate('');
      setRemindMeBefore('');
      setDocumentIssuingAuthority('');
      setOtherComments('');
    } catch (error) {
      console.error('Error uploading files:', error);
      notifyError('Failed to upload files. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Load available categories for parent selection
  useEffect(() => {
    if (showFolderModal) {
      const loadClassifications = async () => {
        setLoadingClassificationsForParent(true);
        try {
          const userData = JSON.parse(localStorage.getItem('user'));
          const corporateId = userData?.corporateId || userData?.id;
          
          const response = await axiosInstance.get(`/document-categories?corporate_id=${corporateId}`);
          const data = response.data;
          
          if (response.status === 200) {
            const classifications = data.success ? data.data : (data.data || data || []);
            setAvailableClassificationsForParent(classifications);
            
            // Prefill parent_id if filterClassification is set (user is viewing a specific classification)
            if (prefillParentId) {
              setClassificationFormData(prev => ({
                ...prev,
                parent_id: prefillParentId
              }));
            } else if (filterClassification && filterClassification.value) {
              // If user has filtered by a classification, prefill that as parent
              setClassificationFormData(prev => ({
                ...prev,
                parent_id: filterClassification.value
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching classifications:", error);
        } finally {
          setLoadingClassificationsForParent(false);
        }
      };
      
      loadClassifications();
    } else {
      // Reset prefill when modal closes
      setPrefillParentId(null);
    }
  }, [showFolderModal, prefillParentId, filterClassification]);

  const FIELD_TYPES = [
    { value: "0", label: "Select Type" },
    { value: "text", label: "Text (varchar 200)" },
    { value: "date", label: "Date (date)" },
    { value: "address", label: "Address (longtext)" }
  ];

  const createField = () => ({ 
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`, 
    fieldName: "", 
    fieldType: "0" 
  });

  const handleClassificationFormChange = (e, index, type) => {
    if (type === "classification") {
      setClassificationFormData({ ...classificationFormData, name: e.target.value });
      if (classificationFormErrors.name) {
        const { name, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    } else if (type === "parent_id") {
      const parentId = e.target.value === "" ? null : parseInt(e.target.value);
      setClassificationFormData({ ...classificationFormData, parent_id: parentId });
      if (classificationFormErrors.parent_id) {
        const { parent_id, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    } else {
      const updatedFields = [...classificationFormData.fields];
      updatedFields[index][type] = e.target.value;
      setClassificationFormData({ ...classificationFormData, fields: updatedFields });
      const key = `${type}_${index}`;
      if (classificationFormErrors[key]) {
        const { [key]: _, ...rest } = classificationFormErrors;
        setClassificationFormErrors(rest);
      }
    }
  };

  const addClassificationField = () => {
    setClassificationFormData({
      ...classificationFormData,
      fields: [...classificationFormData.fields, createField()]
    });
  };

  const deleteClassificationField = (index) => {
    if (classificationFormData.fields.length === 1) {
      notifyError("At least one field is required!");
      return;
    }
    const updatedFields = classificationFormData.fields.filter((_, i) => i !== index);
    setClassificationFormData({ ...classificationFormData, fields: updatedFields });
  };

  const validateClassificationForm = () => {
    const newErrors = {};

    if (!classificationFormData.name.trim()) {
      newErrors.name = 'Document Classification name is required';
    }

    const seenNames = new Set();
    classificationFormData.fields.forEach((f, idx) => {
      if (!f.fieldName.trim()) {
        newErrors[`fieldName_${idx}`] = "Field name required";
      }
      if (f.fieldType === "0") {
        newErrors[`fieldType_${idx}`] = "Select field type";
      }
      const normalized = f.fieldName.trim().toLowerCase();
      if (normalized) {
        if (seenNames.has(normalized)) {
          newErrors[`fieldName_${idx}`] = "Duplicate field name";
        }
        seenNames.add(normalized);
      }
    });
    
    setClassificationFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateClassification = async () => {
    if (!validateClassificationForm()) return;

    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem('user'));
      const corporateId = userData?.corporateId || userData?.id;
      
      // Transform fields for backend API
      const payloadFields = classificationFormData.fields.map((f, idx) => ({
        field_name: f.fieldName,
        field_type: f.fieldType,
        field_order: idx + 1,
        is_required: false
      }));

      const payload = {
        name: classificationFormData.name.trim(),
        corporate_id: parseInt(corporateId),
        fields: payloadFields,
      };

      // Add parent_id if selected
      if (classificationFormData.parent_id) {
        payload.parent_id = classificationFormData.parent_id;
      }
      
      const response = await axiosInstance.post('/document-categories', payload);
      
      if (response.status === 200 || response.status === 201) {
        const responseData = response.data;
        
        if (responseData.success) {
          notifySuccess(responseData.message || 'Document Classification created successfully');
          setShowFolderModal(false);
          setClassificationFormData({
            name: '',
            parent_id: null,
            fields: [createField()]
          });
          setClassificationFormErrors({});
          // Reload classifications and documents
          await loadDocumentClassifications();
          // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
        } else {
          notifyError(responseData.message || 'Failed to create classification');
        }
      }
    } catch (error) {
      console.error('Error creating classification:', error);
      if (error.response?.status === 409) {
        notifyError('Document Classification already exists');
      } else {
        const errorMessage = error.response?.data?.message || 
                            error.response?.data?.error || 
                            'Failed to create Document Classification';
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCheck = async (item) => {
    if (!item) return;

    // For documents, proceed directly to delete (no check needed)
    if (item.type !== 'folder') {
      setSelectedItem(item);
      setShowDeleteModal(true);
      return;
    }

    // For folders, check if they contain documents or sub-folders
    setCheckLoading(true);
    try {
      const res = await axiosInstance.get(`/document-categories/${item.id}/check`);
      const data = res.data;

      if (res && data.success) {
        const statistics = data.data?.statistics || {};
        const totalClassifications = statistics.total_classifications || 0;
        const totalDocuments = statistics.total_documents || 0;

        // If there are documents or classifications, show first warning modal
        if (totalClassifications > 0 || totalDocuments > 0) {
          setDeleteCheckData(data.data);
          setSelectedItem(item);
          setShowFirstDeleteModal(true);
        } else {
          // No documents or classifications, proceed directly to delete
          setSelectedItem(item);
          setShowDeleteModal(true);
        }
      } else {
        // If check fails, proceed with delete anyway
        setSelectedItem(item);
        setShowDeleteModal(true);
      }
    } catch (error) {
      console.error('Delete check error:', error);
      // If check fails, proceed with delete anyway
      setSelectedItem(item);
      setShowDeleteModal(true);
    } finally {
      setCheckLoading(false);
    }
  };

  const handleFirstDeleteConfirm = () => {
    if (!deleteCheckData) return;

    const statistics = deleteCheckData.statistics || {};
    const otherUserDocuments = statistics.other_user_documents || 0;
    const privateClassificationsByOthers = statistics.private_classifications_by_others || 0;

    // Close first modal
    setShowFirstDeleteModal(false);

    // If there are other users' documents or private classifications, show second warning
    if (otherUserDocuments > 0 || privateClassificationsByOthers > 0) {
      setShowSecondDeleteModal(true);
    } else {
      // No other users' content, proceed with delete
      performDelete();
    }
  };

  const handleSecondDeleteConfirm = () => {
    setShowSecondDeleteModal(false);
    performDelete();
  };

  const performDelete = async () => {
    if (!selectedItem) return;

    try {
      setLoading(true);
      
      let response;
      if (selectedItem.type === 'folder') {
        // Delete folder API
        response = await axiosInstance.delete(`/documents/folder/${selectedItem.id}`);
      } else {
        // Delete document API
        response = await axiosInstance.delete(`/documents/${selectedItem.id}`);
      }

      // Check response success
      if (response.status === 200 || response.status === 204) {
        const responseData = response.data;
        
        // Handle different response structures
        if (responseData && responseData.success === false) {
          notifyError(responseData.message || `Failed to delete ${selectedItem.type}`);
        } else {
          const successMessage = responseData?.message || 
                                `${selectedItem.type === 'folder' ? 'Folder' : 'File'} deleted successfully`;
          notifySuccess(successMessage);
          setShowDeleteModal(false);
          setShowFirstDeleteModal(false);
          setShowSecondDeleteModal(false);
          setSelectedItem(null);
          setDeleteCheckData(null);
          // Reload documents from API
          // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
        }
      }
    } catch (error) {
      console.error('Error deleting item:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          `Failed to delete ${selectedItem.type}`;
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    // This function is kept for backward compatibility but now calls performDelete
    await performDelete();
  };

  const handleMove = (targetFolderId) => {
    if (!selectedItem) return;

    if (selectedItem.type === 'folder') {
      const updatedFolders = staticFolders.map(f =>
        f.id === selectedItem.id ? { ...f, parent_id: targetFolderId } : f
      );
      setStaticFolders(updatedFolders);
    } else {
      const updatedDocs = staticDocuments.map(d =>
        d.id === selectedItem.id ? { ...d, folder_id: targetFolderId } : d
      );
      setStaticDocuments(updatedDocs);
    }

    notifySuccess('Item moved successfully');
    setShowMoveModal(false);
    setSelectedItem(null);
    // Reset to page 1 after move
    setPagination(prev => ({ ...prev, page: 1 }));
    loadDocuments(1);
  };

  // Scroll-based pagination handler
  useEffect(() => {
    if (viewMode === 'table') {
      // For table view, use table wrapper scroll
      const handleTableScroll = (event) => {
        const threshold = 5;
        const wrapper = event.target;
        if (wrapper && wrapper.classList.contains('table-wrapper')) {
          const isNearBottom = wrapper.scrollHeight - wrapper.scrollTop <= wrapper.clientHeight + threshold;
          if (isNearBottom && pagination.hasMore && !loadingMore && !loading) {
            const nextPage = pagination.page + 1;
            setPagination(prev => ({ ...prev, page: nextPage }));
            loadDocuments(nextPage, true);
          }
        }
      };

      const wrapper = document.querySelector('.table-wrapper');
      if (wrapper) {
        wrapper.addEventListener('scroll', handleTableScroll);
        return () => {
          wrapper.removeEventListener('scroll', handleTableScroll);
        };
      }
      return () => {};
    } else {
      // For tile/card view, use window scroll
      const handleWindowScroll = () => {
        const threshold = 5;
        const isNearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold;
        if (isNearBottom && pagination.hasMore && !loadingMore && !loading) {
          const nextPage = pagination.page + 1;
          setPagination(prev => ({ ...prev, page: nextPage }));
          loadDocuments(nextPage, true);
        }
      };

      window.addEventListener('scroll', handleWindowScroll);
      return () => {
        window.removeEventListener('scroll', handleWindowScroll);
      };
    }
  }, [pagination.hasMore, loadingMore, loading, pagination.page, viewMode, documents]);

  const handleDocumentClick = (file) => {
    // Navigate to document details page (carry list filters in URL for Back / new tab)
    navigate(`/documents/details/${file.id}${getDocumentListQuerySuffix()}`, {
      state: { from: location.pathname }
    });
  };

  const handleDownload = async (file, e) => {
    if (e) {
      e.stopPropagation(); // Prevent navigation when clicking download button
    }
    
    if (!file || !file.id) {
      notifyError('Invalid file');
      return;
    }

    try {
      setLoading(true);
      
      // Download file with blob response type
      const response = await axiosInstance.get(`/documents/${file.id}/download`, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/octet-stream'
        }
      });

      if (response.status === 200) {
        // Get filename from Content-Disposition header or use file name
        let fileName = file.name || file.file_name || 'document';
        
        // Try to extract filename from Content-Disposition header
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''));
          }
        }

        // Create blob URL and trigger download
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        notifySuccess('File downloaded successfully');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
      
      // Handle blob error response (if API returns JSON error in blob format)
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorJson = JSON.parse(errorText);
          notifyError(errorJson.message || 'Failed to download file');
        } catch (parseError) {
          notifyError('Failed to download file');
        }
      } else {
        const errorMessage = error.response?.data?.message || 
                            error.response?.data?.error || 
                            'Failed to download file';
        notifyError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAddFavorite = async (file) => {
    if (!file || !file.id) {
      notifyError('Invalid file');
      return;
    }

    try {
      setLoading(true);
      
      const response = await axiosInstance.put(`/documents/${file.id}/favorite`);

      if (response.status === 200 || response.status === 204) {
        const isFavorited = response.data?.is_favorite ?? true;
        if (isFavorited) {
          notifySuccess('Document added to favorites');
        } else {
          notifySuccess('Document removed from favorites');
        }
        // Refresh the document list to update favorite status
        // Reset to page 1 after share
        setPagination(prev => ({ ...prev, page: 1 }));
        await loadDocuments(1);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error || 
                          'Failed to toggle favorite';
      notifyError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const getClassificationIcon = (classificationName) => {
    if (!classificationName) return null;
    
    const normalizedName = classificationName.toLowerCase().trim();
    
    // Map classification names to icon types
    const classificationMap = {
      'contracts': 'word',
      'contract': 'word',
      'legal': 'word',
      'reports': 'pdf',
      'report': 'pdf',
      'invoices': 'excel',
      'invoice': 'excel',
      'financial': 'excel',
      'finance': 'excel',
      'hr documents': 'word',
      'hr': 'word',
      'human resources': 'word',
      'project documents': 'word',
      'project': 'word',
      'general': 'file',
      'images': 'image',
      'image': 'image',
      'photos': 'image',
      'photo': 'image',
      'presentations': 'powerpoint',
      'presentation': 'powerpoint',
      'slides': 'powerpoint',
      'spreadsheets': 'excel',
      'spreadsheet': 'excel',
      'documents': 'word',
      'document': 'word',
      'archives': 'archive',
      'archive': 'archive',
      'zip': 'archive'
    };
    
    return classificationMap[normalizedName] || null;
  };

  const getFileIcon = (file) => {
    // First try to get icon from classification
    // const classificationName = file.category_name || file.category?.name;
    // if (classificationName) {
    //   const classificationIcon = getClassificationIcon(classificationName);
    //   if (classificationIcon) {
    //     return classificationIcon;
    //   }
    // }
    
    // Get file extension from file_name first (most reliable)
    let extension = '';
    if (file.file_name) {
      extension = file.file_name.split('.').pop()?.toLowerCase() || '';
    } else if (file.name) {
      extension = file.name.split('.').pop()?.toLowerCase() || '';
    }
    
    // If we have file_type, check if it's a MIME type or extension
    let fileType = file.file_type?.toLowerCase() || '';
    
    if (fileType) {
      // Check if it's a MIME type (contains '/')
      if (fileType.includes('/')) {
        // Extract extension from MIME type
        const mimeToExt = {
          'application/pdf': 'pdf',
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'application/vnd.ms-excel': 'xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'application/vnd.ms-powerpoint': 'ppt',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'image/jpeg': 'jpg',
          'image/jpg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'text/plain': 'txt',
          'application/zip': 'zip',
          'application/x-rar-compressed': 'rar',
          'application/x-zip-compressed': 'zip'
        };
        extension = mimeToExt[fileType] || extension;
      } else {
        // It's already an extension
        if (fileType[0] === '.') {
          fileType = fileType.substring(1);
        }
        extension = fileType || extension;
      }
    }
    
    // Use extension if we have it, otherwise fallback
    const fileTypeKey = extension || fileType || '';
    
    const iconMap = {
      pdf: 'pdf',
      doc: 'word',
      docx: 'word',
      xls: 'excel',
      xlsx: 'excel',
      ppt: 'powerpoint',
      pptx: 'powerpoint',
      jpg: 'image',
      jpeg: 'image',
      png: 'image',
      gif: 'image',
      txt: 'text',
      zip: 'archive',
      rar: 'archive',
      folder: 'folder'
    };

    return iconMap[fileTypeKey] || 'file';
  };

  const getFileIconColor = (fileType) => {
    const colorMap = {
      pdf: '#d93025',
      word: '#2b579a',
      excel: '#1d6f42',
      powerpoint: '#d04423',
      image: '#34a853',
      text: '#6c757d',
      archive: '#ea4335',
      file: '#667eea'
    };
    return colorMap[fileType] || colorMap.file;
  };

  const getClassificationIconComponent = (classificationName, size = 48, isFolder = false) => {
    // Windows folder yellow (not brand red)
    const defaultColor = '#FFB900';
    
    if (!classificationName) {
      return <CategorizationIcon size={size} color={defaultColor} />;
    }
    
    const iconType = getClassificationIcon(classificationName);
    
    switch (iconType) {
      case 'pdf':
        return <FaFilePdf size={size} style={{ color: '#d93025' }} />;
      case 'word':
        return <FaFileWord size={size} style={{ color: '#2b579a' }} />;
      case 'excel':
        return <FaFileExcel size={size} style={{ color: '#1d6f42' }} />;
      case 'powerpoint':
        return <FaFilePowerpoint size={size} style={{ color: '#d04423' }} />;
      case 'image':
        return <FaFileImage size={size} style={{ color: '#34a853' }} />;
      case 'archive':
        return <FaFileArchive size={size} style={{ color: '#ea4335' }} />;
      case 'text':
        return <FaFileAlt size={size} style={{ color: '#6c757d' }} />;
      default:
        return <CategorizationIcon size={size} color={defaultColor} />;
    }
  };

  const getFileIconComponent = (file, size = 48, iconColor = null) => {
    if (file.type === 'folder') {
      // For folders, try to use classification if available
      const classificationName = file.category_name || file.category?.name;
      return getClassificationIconComponent(classificationName, size, true);
    }

    // Get normalized file type using existing getFileIcon function
    const normalizedType = getFileIcon(file);
    const color = iconColor || getFileIconColor(normalizedType);
    
    // Map normalized types to specific Font Awesome icons
    switch (normalizedType) {
      case 'pdf':
        return <FaFilePdf size={size} style={{ color }} />;
      case 'word':
        return <FaFileWord size={size} style={{ color }} />;
      case 'excel':
        return <FaFileExcel size={size} style={{ color }} />;
      case 'powerpoint':
        return <FaFilePowerpoint size={size} style={{ color }} />;
      case 'image':
        return <FaFileImage size={size} style={{ color }} />;
      case 'archive':
        return <FaFileArchive size={size} style={{ color }} />;
      case 'text':
        return <FaFileAlt size={size} style={{ color }} />;
      default:
        return <FiFile size={size} style={{ color }} />;
    }
  };

  // Handle filter branch change - filter departments
  const handleFilterBranchChange = (selectedOption) => {
    const branchId = selectedOption ? selectedOption.value : null;
    setPendingFilterBranch(selectedOption);
    
    if (branchId) {
      // Filter departments based on selected branch
      const filtered = departments.filter(dept => dept.branch_id === branchId);
      setFilteredDepartmentsForFilter(filtered);
      
      // Reset department and sub-department filters if they're no longer valid
      if (pendingFilterDepartment && !filtered.some(d => d.id === pendingFilterDepartment.value)) {
        setPendingFilterDepartment(null);
        setPendingFilterSubDepartment(null);
        setFilteredSubDepartmentsForFilter(subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        }));
      } else if (pendingFilterDepartment) {
        // Update sub-departments based on filtered departments
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        });
        setFilteredSubDepartmentsForFilter(subs);
        
        // Check if current sub-department is still valid
        if (pendingFilterSubDepartment && !subs.some(sd => {
          const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
          return sdId === pendingFilterSubDepartment.value;
        })) {
          setPendingFilterSubDepartment(null);
        }
      } else {
        // Update sub-departments based on filtered departments
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        });
        setFilteredSubDepartmentsForFilter(subs);
      }
    } else {
      // Reset to all departments and sub-departments
      setFilteredDepartmentsForFilter(departments);
      setFilteredSubDepartmentsForFilter(subDepartments);
      setPendingFilterDepartment(null);
      setPendingFilterSubDepartment(null);
    }
  };

  // Handle filter department change - filter sub-departments
  const handleFilterDepartmentChange = (selectedOption) => {
    const departmentId = selectedOption ? selectedOption.value : null;
    setPendingFilterDepartment(selectedOption);
    
    if (departmentId) {
      // Filter sub-departments based on selected department
      let subs = subDepartments.filter(sd => {
        const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
        return sdDeptId === departmentId;
      });
      
      // If branch is also selected, ensure department belongs to branch
      if (pendingFilterBranch) {
        const dept = departments.find(d => d.id === departmentId);
        if (dept && dept.branch_id !== pendingFilterBranch.value) {
          subs = [];
        }
      }
      
      setFilteredSubDepartmentsForFilter(subs);
      
      // Reset sub-department filter if it's no longer valid
      if (pendingFilterSubDepartment && !subs.some(sd => {
        const sdId = sd.id || sd.sub_department_id || sd.subDepartmentId;
        return sdId === pendingFilterSubDepartment.value;
      })) {
        setPendingFilterSubDepartment(null);
      }
    } else {
      // Reset to all sub-departments based on branch (if any)
      if (pendingFilterBranch) {
        const filtered = departments.filter(dept => dept.branch_id === pendingFilterBranch.value);
        const subs = subDepartments.filter(sd => {
          const sdDeptId = sd.department_id || sd.DepartmentId || sd.departmentId;
          return filtered.some(d => d.id === sdDeptId);
        });
        setFilteredSubDepartmentsForFilter(subs);
      } else {
        setFilteredSubDepartmentsForFilter(subDepartments);
      }
      setPendingFilterSubDepartment(null);
    }
  };

  // Handle filter sub-department change
  const handleFilterSubDepartmentChange = (selectedOption) => {
    setPendingFilterSubDepartment(selectedOption);
  };

  // Handle filter classification change
  const handleFilterClassificationChange = (selectedOption) => {
    setPendingFilterClassification(selectedOption);
  };

  // Clear all filters
  const clearAllFilters = () => {
    setFilterClassification(null);
    setFilterBranch(null);
    setFilterDepartment(null);
    setFilterSubDepartment(null);
    setPendingFilterClassification(null);
    setPendingFilterBranch(null);
    setPendingFilterDepartment(null);
    setPendingFilterSubDepartment(null);
    setFilteredDepartmentsForFilter(departments);
    setFilteredSubDepartmentsForFilter(subDepartments);
  };

  // No client-side filtering needed - all filters and search are applied via API
  const filteredFolders = folders;
  const filteredDocuments = documents;

  // Helper function to check if a folder is a favorite classification folder
  const isFavoriteClassificationFolder = (folder) => {
    // Check if folder has direct connection to classification
    if (folder.connection_type === 'category' && folder.connection_id) {
      const category = documentClassifications.find(cat => cat.id === folder.connection_id);
      return category?.is_favorite || false;
    }
    // Fallback: Try matching folder name to classification name
    if (folder.name) {
      const category = documentClassifications.find(cat => 
        cat.name.toLowerCase().trim() === folder.name.toLowerCase().trim()
      );
      return category?.is_favorite || false;
    }
    return false;
  };

  // Create combined and sorted list: favorite classifications, favorite documents, then non-favorites
  const sortedCombinedItems = useMemo(() => {
    // Combine folders and documents with type markers
    const combined = [
      ...filteredFolders.map(f => ({ ...f, type: 'folder', isFavorite: isFavoriteClassificationFolder(f) })),
      ...filteredDocuments.map(d => ({ ...d, type: 'file', isFavorite: d.is_favorite || false }))
    ];

    // Sort with explicit order:
    // 1. Favorite classifications (folders)
    // 2. Favorite documents (files)
    // 3. Non-favorite classifications (folders)
    // 4. Non-favorite documents (files)
    return combined.sort((a, b) => {
      // Both are favorites
      if (a.isFavorite && b.isFavorite) {
        // Favorite folders (classifications) come before favorite files (documents)
        if (a.type === 'folder' && b.type === 'file') return -1;
        if (a.type === 'file' && b.type === 'folder') return 1;
        // Same type, maintain original order
        return 0;
      }
      
      // Both are non-favorites
      if (!a.isFavorite && !b.isFavorite) {
        // Non-favorite folders (classifications) come before non-favorite files (documents)
        if (a.type === 'folder' && b.type === 'file') return -1;
        if (a.type === 'file' && b.type === 'folder') return 1;
        // Same type, maintain original order
        return 0;
      }
      
      // One is favorite, one is not - favorites always come first
      if (a.isFavorite && !b.isFavorite) return -1;
      if (!a.isFavorite && b.isFavorite) return 1;
      
      return 0;
    });
  }, [filteredFolders, filteredDocuments, documentClassifications]);

  // Separate back into folders and documents for rendering, maintaining the sorted order
  const sortedFolders = useMemo(() => {
    return sortedCombinedItems.filter(item => item.type === 'folder').map(({ type, isFavorite, ...rest }) => rest);
  }, [sortedCombinedItems]);

  const sortedDocuments = useMemo(() => {
    return sortedCombinedItems.filter(item => item.type === 'file').map(({ type, isFavorite, ...rest }) => rest);
  }, [sortedCombinedItems]);

  // Handle view mode change
  const handleViewModeChange = (mode) => {
    // Force tile view on mobile screens (width <= 768px)
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      setViewMode('tile');
      saveViewMode('documentList', 'tile');
      return;
    }
    setViewMode(mode);
    saveViewMode('documentList', mode);
  };

  const menuIcon = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  // Get available folders for move operation (exclude current folder)
  const availableFolders = staticFolders.filter(f => f.id !== selectedItem?.id);

  const openUpload = () => {
    const queryParams = new URLSearchParams();
    if (currentFolderId) {
      queryParams.append('folderId', currentFolderId);
    }
    if (filterClassification && filterClassification.value) {
      queryParams.append('categoryId', filterClassification.value);
    }
    const queryString = queryParams.toString();
    navigate(`/documents/upload${queryString ? `?${queryString}` : ''}`);
  };

  const openNewClassification = () => {
    const queryParams = new URLSearchParams();

    if (filterClassification && filterClassification.value) {
      queryParams.append('parent_id', filterClassification.value);
    } else if (currentFolderId) {
      let currentFolder = staticFolders.find(f => f.id === currentFolderId);
      if (!currentFolder) {
        currentFolder = folders.find(f => f.id === currentFolderId);
      }

      if (currentFolder) {
        if (currentFolder.connection_type === 'category' && currentFolder.connection_id) {
          queryParams.append('parent_id', currentFolder.connection_id);
        } else if (currentFolder.name && documentClassifications.length > 0) {
          const matchingClassification = documentClassifications.find(cat =>
            cat.name.toLowerCase().trim() === currentFolder.name.toLowerCase().trim()
          );
          if (matchingClassification) {
            queryParams.append('parent_id', matchingClassification.id);
          }
        }
      }
    }

    const queryString = queryParams.toString();
    navigate(`/documents/addDocumentClassification${queryString ? `?${queryString}` : ''}`);
  };

  const documentsToolbar = useMemo(
    () => (
      <>
        <div className="sort-dropdown task-list-sort">
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              as="button"
              className="header-toolbar-btn"
              title="Sort"
              aria-label="Sort"
            >
              <i className="fas fa-sort-amount-down"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item onClick={() => setSortBy('file_name')}>Name</Dropdown.Item>
              <Dropdown.Item onClick={() => setSortBy('expiry_date')}>Expiry Date</Dropdown.Item>
              <Dropdown.Item onClick={() => setSortBy('updated_at')}>Updated Date</Dropdown.Item>
              <Dropdown.Item onClick={() => setSortBy('file_size')}>File Size</Dropdown.Item>
              <Dropdown.Item onClick={() => setSortBy('file_type')}>File Type</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="view-toggle-container-modern">
          <button
            type="button"
            className={`view-toggle-btn-modern ${viewMode === 'tile' ? 'active' : ''}`}
            onClick={() => handleViewModeChange('tile')}
            title="Tile View"
            aria-label="Tile View"
          >
            <i className="fas fa-th-large"></i>
          </button>
          <button
            type="button"
            className={`view-toggle-btn-modern ${viewMode === 'table' ? 'active' : ''}`}
            onClick={() => handleViewModeChange('table')}
            title="Table View"
            aria-label="Table View"
          >
            <i className="fas fa-list"></i>
          </button>
        </div>
        {canCreateDocuments ? (
          <button
            type="button"
            className="toolbar-add-btn"
            onClick={openUpload}
            title="Upload Document"
            aria-label="Upload Document"
          >
            <FiUpload size={16} />
            <span>Upload Document</span>
          </button>
        ) : null}
        {canCreateClassifications ? (
          <button
            type="button"
            className="toolbar-add-btn toolbar-add-btn--ghost"
            onClick={openNewClassification}
            title="Create Classification"
            aria-label="Create Classification"
          >
            <CategorizationIcon size={16} color="#C42126" />
            <span>Create Classification</span>
          </button>
        ) : null}
      </>
    ),
    [viewMode, canCreateDocuments, canCreateClassifications, currentFolderId, filterClassification, folders, staticFolders, documentClassifications, navigate]
  );

  usePageToolbar(hasAccess ? documentsToolbar : null, [hasAccess, documentsToolbar]);

  const documentsEmptyState = (
    <EmptyState
      icon={<FiFolder />}
      title="No Data Found"
      description={(canCreateDocuments || canCreateClassifications)
        ? 'Get started by uploading a document or creating a new classification'
        : 'No documents found'}
      action={(canCreateDocuments || canCreateClassifications) ? (
        <div className="d-flex gap-3 justify-content-center flex-wrap">
          {canCreateDocuments ? (
          <button
            type="button"
            onClick={openUpload}
            title="Upload Document"
            className="btn"
            style={{
              minWidth: '150px',
              background: 'transparent',
              border: '2px solid #C42126',
              borderRadius: '8px',
              padding: '0.5rem 1.25rem',
              color: '#C42126',
              fontWeight: '600',
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#C42126';
              e.currentTarget.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent';
              e.currentTarget.style.color = '#C42126';
            }}
          >
            <FiUpload />
            <span>Upload</span>
          </button>
          ) : null}
          {canCreateClassifications ? (
          <button
            type="button"
            onClick={openNewClassification}
            title="New Classification"
            onMouseEnter={() => setNewButtonHovered(true)}
            onMouseLeave={() => setNewButtonHovered(false)}
            className="btn"
            style={{
              minWidth: '150px',
              background: newButtonHovered ? '#C42126' : 'transparent',
              border: '2px solid #C42126',
              borderRadius: '8px',
              padding: '0.5rem 1.25rem',
              color: newButtonHovered ? 'white' : '#C42126',
              fontWeight: '600',
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
          >
            <CategorizationIcon size={20} color={newButtonHovered ? 'white' : '#C42126'} />
            <span>New</span>
          </button>
          ) : null}
        </div>
      ) : null}
    />
  );

  // Show loading while checking access
  if (accessLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Don't render if no access (will redirect)
  if (!hasAccess) {
    return null;
  }

  return (
    <div className="document-drive-container">
      <ToastContainer />
      
      <Row style={{marginBottom: "0px !important"}}>
        <Col lg={12}>
          <Card className="user-list-card">
            {/* First Row: Navigation, Action Buttons, and Collapse Button */}
            <div className="document-section-header d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ padding: '1.5rem 1.5rem 1rem 1.5rem', borderBottom: '1px solid #e9ecef' }}>
              {/* Breadcrumb Navigation */}
              <div className="document-header-content">
                <nav aria-label="breadcrumb" className="drive-breadcrumb">
                  <ol className="breadcrumb mb-0">
                    {currentPath
                      .filter(folder => folder.name && folder.name.trim() !== '')
                      .map((folder, index, filteredArray) => (
                        <li key={folder.id || `root-${index}`} className="breadcrumb-item">
                          {index < filteredArray.length - 1 ? (
                            <button 
                              className="breadcrumb-link"
                              onClick={() => handlePathClick(folder)}
                            >
                              {folder.name}
                            </button>
                          ) : (
                            <span className="breadcrumb-current">{folder.name}</span>
                          )}
                        </li>
                      ))}
                  </ol>
                </nav>
              </div>
            </div>

            {/* Filter Panel - Commented Out
            {showFilterPanel && (
              <div className="filter-wrapper" ref={filterRef}>
                <div className="filter-form">
                      <div className="filter-row">
                        <div className="filter-group">
                          <label>Classification</label>
                          <Select
                            placeholder="Select Classification"
                            isClearable
                            value={pendingFilterClassification}
                            onChange={handleFilterClassificationChange}
                            options={documentClassifications.map(cat => ({
                              value: cat.id,
                              label: cat.name
                            }))}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>

                        <div className="filter-group">
                          <label>Branch</label>
                          <Select
                            placeholder="Select Branch"
                            isClearable
                            value={pendingFilterBranch}
                            onChange={handleFilterBranchChange}
                            options={branches.map(branch => ({
                              value: branch.id,
                              label: branch.name || branch.branch_name
                            }))}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>
                      </div>

                      <div className="filter-row">
                        <div className="filter-group">
                          <label>Department</label>
                          <Select
                            placeholder="Select Department"
                            isClearable
                            value={pendingFilterDepartment}
                            onChange={handleFilterDepartmentChange}
                            options={filteredDepartmentsForFilter.map(dept => ({
                              value: dept.id,
                              label: dept.name || dept.department_name
                            }))}
                            isDisabled={pendingFilterBranch === null ? false : filteredDepartmentsForFilter.length === 0}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>

                        <div className="filter-group">
                          <label>Sub-Department</label>
                          <Select
                            placeholder="Select Sub-Department"
                            isClearable
                            value={pendingFilterSubDepartment}
                            onChange={handleFilterSubDepartmentChange}
                            options={filteredSubDepartmentsForFilter.map(sd => ({
                              value: sd.id || sd.sub_department_id || sd.subDepartmentId,
                              label: sd.name || sd.sub_department_name || sd.subDepartmentName
                            }))}
                            isDisabled={pendingFilterDepartment === null ? false : filteredSubDepartmentsForFilter.length === 0}
                            styles={{
                              control: (base) => ({
                                ...base,
                                minHeight: '38px',
                                borderColor: '#e9ecef',
                                '&:hover': {
                                  borderColor: '#ced4da'
                                }
                              })
                            }}
                          />
                        </div>
                      </div>
                </div>

                <div className="filter-actions">
                  <button 
                    className="search-btn" 
                    onClick={() => {
                      // Apply pending filters to actual filter states
                      setFilterClassification(pendingFilterClassification);
                      setFilterBranch(pendingFilterBranch);
                      setFilterDepartment(pendingFilterDepartment);
                      setFilterSubDepartment(pendingFilterSubDepartment);
                      setShowFilterPanel(false);
                    }}
                  >
                    <i className="fas fa-search"></i>
                    Apply Filters
                  </button>
                  <button 
                    className="reset-btn" 
                    onClick={() => {
                      clearAllFilters();
                      setShowFilterPanel(false);
                    }}
                  >
                    <i className="fas fa-undo"></i>
                    Reset
                  </button>
                </div>
              </div>
            )}
            */}

            {/* Files and Folders - Tile or Table View */}
            <Card.Body style={{ minHeight: '400px', overflow: 'visible' }}>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : viewMode === 'tile' ? (
                <Row className="drive-grid">
                  {/* Folders */}
                  {sortedFolders.map((folder) => (
                    <Col key={folder.id} xs={6} sm={4} md={3} lg={2} xl={2} className="drive-item-col">
                      <Card 
                        className="drive-item folder-item" 
                        onClick={(e) => {
                          const target = e.target;
                          if (target.closest('.drive-item-actions') || 
                              target.closest('.dropdown') || 
                              target.closest('.dropdown-toggle') ||
                              target.closest('.dropdown-menu')) {
                            return;
                          }
                          handleFolderClick(folder);
                        }}
                      >
                        <div className="drive-item-icon">
                          {getClassificationIconComponent(folder.category_name || folder.category?.name, 48, true)}
                        </div>
                        <div className="drive-item-name">
                          {(() => {
                            // First check if folder itself is favorited
                            if (folder.is_favorite) {
                              return true;
                            }
                            // Check if folder is a favorite classification
                            if (folder.category?.is_favorite) {
                              return true;
                            }
                            // Otherwise check documentClassifications array
                            const category = documentClassifications.find(cat => 
                              (folder.connection_type === 'category' && folder.connection_id === cat.id) ||
                              (folder.name && cat.name.toLowerCase().trim() === folder.name.toLowerCase().trim())
                            );
                            return category?.is_favorite;
                          })() && (
                            <span className="me-1" style={{ color: '#ffc107' }}>★</span>
                          )}
                          {folder.name}
                        </div>
                        <div className="drive-item-actions" onClick={(e) => e.stopPropagation()}>
                          <Dropdown 
                            drop={dropdownDirections[`folder-${folder.id}`] || 'down'}
                            onToggle={(isOpen, event) => handleDropdownToggle(`folder-${folder.id}`, isOpen, event)}
                          >
                            <Dropdown.Toggle 
                              variant="link" 
                              className="drive-menu-toggle-docs"
                              id={`folder-dropdown-${folder.id}`}
                            >
                              {menuIcon}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {canCreateDocuments ? (
                              <Dropdown.Item 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const queryParams = new URLSearchParams();
                                  queryParams.append('folderId', folder.id);
                                  navigate(`/documents/upload?${queryParams.toString()}`);
                                }}
                              >
                                <FiUpload className="me-2" />
                                Upload Document
                              </Dropdown.Item>
                              ) : null}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Card>
                    </Col>
                  ))}

                  {/* Files */}
                  {sortedDocuments.map((file) => {
                    const fileIconType = getFileIcon(file);
                    const iconColor = getFileIconColor(fileIconType);
                    
                    return (
                    <Col key={file.id} xs={6} sm={4} md={3} lg={2} xl={2} className="drive-item-col">
                      <Card 
                        className="drive-item file-item" 
                        onClick={(e) => {
                          const target = e.target;
                          if (target.closest('.drive-item-actions') || 
                              target.closest('.dropdown') || 
                              target.closest('.dropdown-toggle') ||
                              target.closest('.dropdown-menu')) {
                            return;
                          }
                          handleDocumentClick(file);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="drive-item-icon" style={{ color: iconColor }}>
                          {getFileIconComponent(file, 48)}
                        </div>
                        <div 
                          className="drive-item-name" 
                          title={file.document_title || file.name || file.file_name}
                        >
                          {file.is_favorite && (
                            <span className="me-1" style={{ color: '#ffc107' }}>★</span>
                          )}
                          {file.document_title || file.name || file.file_name}
                        </div>
                        {(file.category?.name || file.category_name) && (
                          <div className="text-muted small mt-auto" style={{ fontSize: '0.75rem', color: '#667eea', marginTop: 'auto' }}>
                            {(() => {
                              // Check if classification is favorited
                              const categoryName = file.category?.name || file.category_name;
                              return file.category?.is_favorite || (categoryName && (() => {
                                const category = documentClassifications.find(cat => 
                                  (file.category_id && cat.id === file.category_id) ||
                                  (categoryName && cat.name.toLowerCase().trim() === categoryName.toLowerCase().trim())
                                );
                                return category?.is_favorite;
                              })());
                            })() && (
                              <span className="me-1" style={{ color: '#ffc107' }}>★</span>
                            )}
                            {file.category?.name || file.category_name}
                          </div>
                        )}
                        <div className="drive-item-actions" onClick={(e) => e.stopPropagation()}>
                          <Dropdown 
                            drop={dropdownDirections[`file-${file.id}`] || 'down'}
                            onToggle={(isOpen, event) => handleDropdownToggle(`file-${file.id}`, isOpen, event)}
                          >
                            <Dropdown.Toggle 
                              variant="link" 
                              className="drive-menu-toggle-docs"
                              id={`file-dropdown-${file.id}`}
                            >
                              {menuIcon}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {canCreateDocuments ? (
                              <Dropdown.Item 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/documents/edit/${file.id}`);
                                }}
                              >
                                <FiEdit2 className="me-2" />
                                Edit
                              </Dropdown.Item>
                              ) : null}
                              {canShareDocuments ? (
                              <Dropdown.Item 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedItem(file);
                                  setShowShareModal(true);
                                  setShareFilteredDepartments(departments);
                                  setShareFilteredSubDepartments(subDepartments);
                                  setShareFilteredUsers(availableUsers);
                                }}
                              >
                                <FiShare2 className="me-2" />
                                Share
                              </Dropdown.Item>
                              ) : null}
                              <Dropdown.Item 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddFavorite(file);
                                }}
                              >
                                <FiStar className="me-2" />
                                Add to Favorites
                              </Dropdown.Item>
                              {canDeleteDocuments ? (
                              <Dropdown.Item 
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  await handleDeleteCheck({ ...file, type: 'file' });
                                }}
                                className="text-danger"
                              >
                                <FiTrash2 className="me-2" />
                                Delete
                              </Dropdown.Item>
                              ) : null}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Card>
                    </Col>
                    );
                  })}

                  {/* Empty State */}
                  {filteredFolders.length === 0 && filteredDocuments.length === 0 && (
                    <Col xs={12}>
                      {documentsEmptyState}
                    </Col>
                  )}
                </Row>
              ) : (
                <div className="row">
                  {filteredFolders.length === 0 && filteredDocuments.length === 0 ? (
                    <div className="col-12">
                      {documentsEmptyState}
                    </div>
                  ) : (
                  <CommonTable
                    columns={[
                      {
                        key: 'icon',
                        header: '',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {getClassificationIconComponent(row.category_name || row.category?.name, 20, true)}
                              </div>
                            );
                          } else {
                            const fileIconType = getFileIcon(row);
                            const iconColor = getFileIconColor(fileIconType);
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {getFileIconComponent(row, 20, iconColor)}
                              </div>
                            );
                          }
                        },
                        cellClassName: 'width80',
                      },
                      {
                        key: 'title',
                        header: 'Title',
                        render: (row) => {
                          if (row.type === 'folder') {
                            // Check if folder is favorited or is a favorite classification
                            // First check if folder itself is favorited
                            const isFavorite = row.is_favorite || row.category?.is_favorite || (() => {
                              const category = documentClassifications.find(cat => 
                                (row.connection_type === 'category' && row.connection_id === cat.id) ||
                                (row.name && cat.name.toLowerCase().trim() === row.name.toLowerCase().trim())
                              );
                              return category?.is_favorite;
                            })();
                            return (
                              <div 
                                onClick={() => handleFolderClick(row)}
                                style={{ cursor: 'pointer', color: '#2c3e50', fontWeight: '500' }}
                                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                                onMouseLeave={(e) => e.target.style.color = '#2c3e50'}
                              >
                                {isFavorite && (
                                  <span className="me-2" style={{ color: '#ffc107' }}>★</span>
                                )}
                                {row.name}
                              </div>
                            );
                          } else {
                            return (
                              <div 
                                onClick={() => handleDocumentClick(row)}
                                style={{ cursor: 'pointer', color: '#2c3e50', fontWeight: '500' }}
                                onMouseEnter={(e) => e.target.style.color = '#667eea'}
                                onMouseLeave={(e) => e.target.style.color = '#2c3e50'}
                              >
                                {row.is_favorite && (
                                  <span className="me-2" style={{ color: '#ffc107' }}>★</span>
                                )}
                                {row.document_title || row.name || row.file_name}
                              </div>
                            );
                          }
                        },
                      },
                      {
                        key: 'classification',
                        header: 'Classification',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return <span className="text-muted">—</span>;
                          } else {
                            // Check if classification is favorited
                            const categoryName = row.category?.name || row.category_name;
                            const isClassificationFavorite = row.category?.is_favorite || (categoryName && (() => {
                              const category = documentClassifications.find(cat => 
                                (row.category_id && cat.id === row.category_id) ||
                                (categoryName && cat.name.toLowerCase().trim() === categoryName.toLowerCase().trim())
                              );
                              return category?.is_favorite;
                            })());
                            
                            return (
                              <div 
                                onClick={() => {
                                  // Navigate or filter by classification
                                  if (row.category_id || row.category?.name || row.category_name) {
                                    // Could filter by classification here
                                  }
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {isClassificationFavorite && (
                                  <span className="me-2" style={{ color: '#ffc107' }}>★</span>
                                )}
                                <span className="text-muted">{categoryName || 'N/A'}</span>
                              </div>
                            );
                          }
                        },
                      },
                      {
                        key: 'reference',
                        header: 'Reference Number',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return <span className="text-muted">—</span>;
                          } else {
                            return <span className="text-muted">{row.reference_number || row.document_reference_number || 'N/A'}</span>;
                          }
                        },
                      },
                      {
                        key: 'expiry',
                        header: 'Expiry Date',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return <span className="text-muted">—</span>;
                          } else {
                            return (
                              <span className="text-muted">
                                {row.expiry_date ? new Date(row.expiry_date).toLocaleDateString() : 'N/A'}
                              </span>
                            );
                          }
                        },
                      },
                      {
                        key: 'updated',
                        header: 'Updated Date',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return <span className="text-muted">{row.updated_at || row.created_at ? new Date(row.updated_at || row.created_at).toLocaleDateString() : 'N/A'}</span>;
                          } else {
                            return (
                              <span className="text-muted">
                                {row.updated_at || row.created_at ? new Date(row.updated_at || row.created_at).toLocaleDateString() : 'N/A'}
                              </span>
                            );
                          } 
                        },
                      },
                      {
                        key: 'uploadedBy',
                        header: 'Uploaded by',
                        render: (row) => {
                          if (row.type === 'folder') {
                            return (
                              <div 
                                onClick={() => handleFolderClick(row)}
                                style={{ cursor: 'pointer' }}
                              >
                                <span className="text-muted">{row.created_by_name || '—'}</span>
                              </div>
                            );
                          } else {
                            return (
                              <span className="text-muted">
                                {row.uploaded_by?.full_name || row.uploaded_by_name || (typeof row.uploaded_by === 'string' ? row.uploaded_by : null) || row.created_by_name || 'N/A'}
                              </span>
                            );
                          }
                        },
                      },
                    ]}
                    data={sortedCombinedItems.map(({ isFavorite, ...item }) => item)}
                    actions={(row, rowIndex) => {
                      if (row.type === 'folder') {
                        if (!canCreateDocuments) return [];
                        return [
                          {
                            label: 'Upload Document',
                            icon: 'fas fa-upload',
                            onClick: () => {
                              const queryParams = new URLSearchParams();
                              queryParams.append('folderId', row.id);
                              navigate(`/documents/upload?${queryParams.toString()}`);
                            },
                          },
                        ];
                      } else {
                        const actions = [];
                        if (canCreateDocuments) {
                          actions.push({
                            label: 'Edit',
                            icon: 'fas fa-edit',
                            onClick: () => {
                              navigate(`/documents/edit/${row.id}`);
                            },
                          });
                        }
                        if (canDownloadDocuments) {
                          actions.push({
                            label: 'Download',
                            icon: 'fas fa-download',
                            onClick: () => handleDownload(row),
                          });
                        }
                        if (canShareDocuments) {
                          actions.push({
                            label: 'Share',
                            icon: 'fas fa-share',
                            onClick: () => {
                              setSelectedItem(row);
                              setShowShareModal(true);
                              setShareFilteredDepartments(departments);
                              setShareFilteredSubDepartments(subDepartments);
                              setShareFilteredUsers(availableUsers);
                            },
                          });
                        }
                        actions.push({
                            label: 'Add to Favorites',
                            icon: 'fas fa-star',
                            onClick: () => handleAddFavorite(row),
                        });
                        if (canDeleteDocuments) {
                          actions.push({
                            label: 'Delete',
                            icon: 'fas fa-trash',
                            className: 'text-danger',
                            onClick: async () => {
                              await handleDeleteCheck({ ...row, type: 'file' });
                            },
                          });
                        }
                        return actions;
                      }
                    }}
                    emptyMessage="No files or folders"
                    emptyStateIcon="fas fa-folder-open"
                    getRowId={(row, index) => row.type === 'folder' ? `folder-${row.id}` : `file-${row.id}`}
                    maxHeight="85vh"
                    minHeight="530px"
                  />
                  )}
                </div>
              )}
              {/* Loading More Indicator */}
              {loadingMore && (
                <div className="d-flex justify-content-center align-items-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading more documents...</span>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Upload Modal */}
      <Modal 
        show={showUploadModal} 
        onHide={() => {
          setShowUploadModal(false);
          setUploadFiles([]);
          setSelectedCategory(null);
          setDynamicFields({});
          setIsPrivate(false);
          setSelectedBranches([]);
          setSelectedDepartments([]);
          setSelectedSubDepartments([]);
          setSelectedUsers([]);
          setFilteredDepartments(departments);
          setFilteredSubDepartments(subDepartments);
          setDuplicateFiles([]);
          // Reset new document fields
          setDocumentTitle('');
          setDocumentRegisteredTo('');
          setDocumentReferenceNumber('');
          setDocumentIssueDate('');
          setDocumentExpiryDate('');
          setRemindMeBefore('');
          setDocumentIssuingAuthority('');
          setOtherComments('');
          setFieldErrors({ documentTitle: '', documentRegisteredTo: '', documentReferenceNumber: '', documentIssuingAuthority: '', otherComments: '' });
        }} 
        size="lg"
        dialogClassName="modal-top"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DocumentUploadForm
            files={uploadFiles}
            onFilesChange={setUploadFiles}
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
            folderId={currentFolderId}
            categories={documentClassifications}
            dynamicFields={dynamicFields}
            onDynamicFieldsChange={setDynamicFields}
            isPrivate={isPrivate}
            onIsPrivateChange={setIsPrivate}
            selectedBranches={selectedBranches}
            onBranchesChange={handleBranchChange}
            selectedDepartments={selectedDepartments}
            onDepartmentsChange={handleDepartmentChange}
            selectedSubDepartments={selectedSubDepartments}
            onSubDepartmentsChange={handleSubDepartmentChange}
            branches={branches}
            departments={departments}
            subDepartments={subDepartments}
            filteredDepartments={filteredDepartments}
            filteredSubDepartments={filteredSubDepartments}
            availableUsers={filteredUsers}
            selectedUsers={selectedUsers}
            onUsersChange={handleUserChange}
            documentTitle={documentTitle}
            onDocumentTitleChange={(v) => { setDocumentTitle(v); setFieldErrors(prev => ({ ...prev, documentTitle: '' })); }}
            documentTitleError={fieldErrors.documentTitle}
            documentRegisteredTo={documentRegisteredTo}
            onDocumentRegisteredToChange={(v) => { setDocumentRegisteredTo(v); setFieldErrors(prev => ({ ...prev, documentRegisteredTo: '' })); }}
            documentRegisteredToError={fieldErrors.documentRegisteredTo}
            documentReferenceNumber={documentReferenceNumber}
            onDocumentReferenceNumberChange={(v) => { setDocumentReferenceNumber(v); setFieldErrors(prev => ({ ...prev, documentReferenceNumber: '' })); }}
            documentReferenceNumberError={fieldErrors.documentReferenceNumber}
            documentIssueDate={documentIssueDate}
            onDocumentIssueDateChange={setDocumentIssueDate}
            documentExpiryDate={documentExpiryDate}
            onDocumentExpiryDateChange={setDocumentExpiryDate}
            remindMeBefore={remindMeBefore}
            onRemindMeBeforeChange={setRemindMeBefore}
            documentIssuingAuthority={documentIssuingAuthority}
            onDocumentIssuingAuthorityChange={(v) => { setDocumentIssuingAuthority(v); setFieldErrors(prev => ({ ...prev, documentIssuingAuthority: '' })); }}
            documentIssuingAuthorityError={fieldErrors.documentIssuingAuthority}
            otherComments={otherComments}
            onOtherCommentsChange={(v) => { setOtherComments(v); setFieldErrors(prev => ({ ...prev, otherComments: '' })); }}
            otherCommentsError={fieldErrors.otherComments}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => {
            setShowUploadModal(false);
            setUploadFiles([]);
            setSelectedCategory(null);
            setDynamicFields({});
            setIsPrivate(false);
            setSelectedBranches([]);
            setSelectedDepartments([]);
            setSelectedSubDepartments([]);
            setSelectedUsers([]);
            setFilteredDepartments(departments);
            setFilteredSubDepartments(subDepartments);
            setDuplicateFiles([]);
            // Reset new document fields
            setDocumentTitle('');
            setDocumentRegisteredTo('');
            setDocumentReferenceNumber('');
            setDocumentIssueDate('');
            setDocumentExpiryDate('');
            setRemindMeBefore('');
            setDocumentIssuingAuthority('');
            setOtherComments('');
            setFieldErrors({ documentTitle: '', documentRegisteredTo: '', documentReferenceNumber: '', documentIssuingAuthority: '', otherComments: '' });
          }}>
            Cancel
          </Button>
          <Button 
            className="doc-form-submit-btn"
            onClick={handleFileUpload}
            disabled={uploadFiles.length === 0 || !documentTitle || documentTitle.trim() === ''}
          >
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Duplicate Files Modal */}
      <Modal 
        show={showDuplicateModal} 
        onHide={() => {
          setShowDuplicateModal(false);
          setDuplicateFiles([]);
          setDuplicateChoices({});
        }} 
        centered 
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Duplicate Files Found</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3">
            The following files already exist. Choose an action for each file:
          </p>
          {duplicateFiles.map((dup, index) => (
            <div key={index} className="mb-3 p-3" style={{ border: '1px solid #e9ecef', borderRadius: '6px', backgroundColor: '#f8f9fa' }}>
              <div className="mb-2">
                <strong>{dup.file.name}</strong>
                {dup.duplicateData && (
                  <small className="text-muted d-block mt-1">
                    Existing file found in: {dup.duplicateData.location || 'Unknown location'}
                  </small>
                )}
              </div>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  id={`replace-${index}`}
                  name={`duplicate-choice-${index}`}
                  label="Replace existing file"
                  checked={duplicateChoices[dup.file.name] === 'replace'}
                  onChange={() => {
                    setDuplicateChoices({
                      ...duplicateChoices,
                      [dup.file.name]: 'replace'
                    });
                  }}
                />
                <Form.Check
                  type="radio"
                  id={`copy-${index}`}
                  name={`duplicate-choice-${index}`}
                  label="Keep as copy (rename)"
                  checked={duplicateChoices[dup.file.name] === 'copy'}
                  onChange={() => {
                    setDuplicateChoices({
                      ...duplicateChoices,
                      [dup.file.name]: 'copy'
                    });
                  }}
                />
              </div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="doc-form-cancel-btn" 
            onClick={() => {
              setShowDuplicateModal(false);
              setDuplicateFiles([]);
              setDuplicateChoices({});
            }}
          >
            Cancel
          </Button>
          <Button 
            className="doc-form-submit-btn"
            onClick={() => {
              proceedWithUpload(uploadFiles, duplicateChoices);
            }}
          >
            Continue Upload
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Create Document Classification Modal */}
      <Modal show={showFolderModal} onHide={() => {
        setShowFolderModal(false);
        setClassificationFormData({
          name: '',
          parent_id: null,
          fields: [createField()]
        });
        setClassificationFormErrors({});
        setPrefillParentId(null);
      }} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New Document Classification</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Document Classification Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter document classification name"
                    value={classificationFormData.name}
                    onChange={(e) => handleClassificationFormChange(e, null, "classification")}
                  />
                  {classificationFormErrors.name && (
                    <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                      {classificationFormErrors.name}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Parent Classification (Optional)</Form.Label>
                  <Form.Select
                    value={classificationFormData.parent_id || ""}
                    onChange={(e) => handleClassificationFormChange(e, null, "parent_id")}
                    disabled={loadingClassificationsForParent}
                    style={{ height: '50px' }}
                    className="form-control"
                  >
                    <option value="">None (Top Level Classification)</option>
                    {availableClassificationsForParent.map(cat => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                  {classificationFormData.parent_id && (
                    <small className="text-muted" style={{ marginTop: '0.25rem', display: 'block' }}>
                      This classification will be created as a sub-classification
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Fields</h6>
              <Button
                variant="success"
                size="sm"
                onClick={addClassificationField}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FiPlus style={{ marginRight: '0.25rem' }} /> Add Field
              </Button>
            </div>

            {classificationFormData.fields.map((field, index) => (
              <div
                key={field.id || index}
                className="mb-3 p-3"
                style={{ backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6' }}
              >
                <Row>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>
                        Field Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter field name"
                        value={field.fieldName}
                        onChange={(e) => handleClassificationFormChange(e, index, "fieldName")}
                      />
                      {classificationFormErrors[`fieldName_${index}`] && (
                        <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                          {classificationFormErrors[`fieldName_${index}`]}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>
                        Field Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={field.fieldType}
                        onChange={(e) => handleClassificationFormChange(e, index, "fieldType")}
                        style={{ height: '50px' }}
                        className="form-control"
                      >
                        {FIELD_TYPES.map(type => (
                          <option key={type.value} value={type.value}>{type.label}</option>
                        ))}
                      </Form.Select>
                      {classificationFormErrors[`fieldType_${index}`] && (
                        <div className="text-danger" style={{ marginTop: '0.25rem', fontSize: '0.875rem' }}>
                          {classificationFormErrors[`fieldType_${index}`]}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => deleteClassificationField(index)}
                      title="Delete field"
                    >
                      <FiTrash2 />
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            className="doc-form-cancel-btn" 
            onClick={() => {
              setShowFolderModal(false);
              setClassificationFormData({
                name: '',
                parent_id: null,
                fields: [createField()]
              });
              setClassificationFormErrors({});
            }}
          >
            Cancel
          </Button>
          <Button 
            className="doc-form-submit-btn"
            onClick={handleCreateClassification}
            disabled={loading || !classificationFormData.name.trim()}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Creating...
              </>
            ) : (
              'Create Classification'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* First Delete Confirmation Modal - Shows when folder contains documents/classifications */}
      <Modal show={showFirstDeleteModal} onHide={() => {
        setShowFirstDeleteModal(false);
        setDeleteCheckData(null);
        setSelectedItem(null);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Warning: Folder Contains Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteCheckData && (() => {
            const statistics = deleteCheckData.statistics || {};
            const totalClassifications = statistics.total_classifications || 0;
            const totalDocuments = statistics.total_documents || 0;
            const currentUserDocuments = statistics.current_user_documents || 0;

            return (
              <div>
                <p className="text-danger mb-0">
                  <strong>Warning:</strong> The folder "<strong>{selectedItem?.name}</strong>" contains sub-folders and/or documents. Deleting this folder will also delete all sub-folders and documents under it. This action cannot be undone.
                </p>
              </div>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => {
            setShowFirstDeleteModal(false);
            setDeleteCheckData(null);
            setSelectedItem(null);
          }}>
            Cancel
          </Button>
          <Button
            className="doc-form-submit-btn"
            onClick={handleFirstDeleteConfirm}
            disabled={checkLoading}
          >
            Yes, Delete Anyway
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Second Delete Confirmation Modal - Shows when there are other users' documents */}
      <Modal show={showSecondDeleteModal} onHide={() => {
        setShowSecondDeleteModal(false);
        setDeleteCheckData(null);
        setSelectedItem(null);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Warning: Other Users' Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteCheckData && (() => {
            const statistics = deleteCheckData.statistics || {};
            const otherUserDocuments = statistics.other_user_documents || 0;
            const privateClassificationsByOthers = statistics.private_classifications_by_others || 0;

            return (
              <div>
                <p className="text-danger mb-0">
                  <strong>Warning:</strong> This folder contains documents or sub-folders uploaded/created by other users that you cannot see. Deleting this folder will permanently delete these items that belong to other users. This action cannot be undone.
                </p>
              </div>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => {
            setShowSecondDeleteModal(false);
            setDeleteCheckData(null);
            setSelectedItem(null);
          }}>
            Cancel
          </Button>
          <Button
            className="doc-form-submit-btn"
            onClick={handleSecondDeleteConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Yes, Delete Anyway'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Standard Delete Confirmation Modal - For documents or empty folders */}
      <Modal show={showDeleteModal} onHide={() => {
        setShowDeleteModal(false);
        setSelectedItem(null);
      }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete "{selectedItem?.name || selectedItem?.file_name || selectedItem?.document_title}"? 
          This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => {
            setShowDeleteModal(false);
            setSelectedItem(null);
          }}>
            Cancel
          </Button>
          <Button className="doc-form-submit-btn" onClick={handleDelete} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Move Modal */}
      <Modal show={showMoveModal} onHide={() => setShowMoveModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Move Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Destination Folder</Form.Label>
              <Form.Select onChange={(e) => {
                const targetId = e.target.value === 'root' ? null : parseInt(e.target.value);
                handleMove(targetId);
              }}>
                <option value="root">My Documents (Root)</option>
                {availableFolders.map(folder => (
                  <option key={folder.id} value={folder.id}>
                    {folder.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="doc-form-cancel-btn" onClick={() => setShowMoveModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Share Document Modal */}
      <ShareDocumentModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        fileId={selectedItem?.id}
        selectedBranches={shareSelectedBranches}
        onBranchesChange={handleShareBranchChange}
        selectedDepartments={shareSelectedDepartments}
        onDepartmentsChange={handleShareDepartmentChange}
        selectedSubDepartments={shareSelectedSubDepartments}
        onSubDepartmentsChange={handleShareSubDepartmentChange}
        branches={branches}
        departments={departments}
        subDepartments={subDepartments}
        filteredDepartments={shareFilteredDepartments}
        filteredSubDepartments={shareFilteredSubDepartments}
        availableUsers={shareFilteredUsers}
        selectedUsers={shareSelectedUsers}
        onUsersChange={handleShareUserChange}
        onInternalShare={handleShareDocument}
        onEmailShare={handleEmailShareDocument}
        sharing={sharing}
        onReset={resetShareForm}
      />

      <BackToTop />
      <InternalFooter />
    </div>
  );
};

export default DocumentList;
